import { OnInit, NgZone, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'
import { } from 'googlemaps';
import { User } from '../_models/index';
import { UserService, CookieService, PackageService, ProductService, DataSourcesService, IntroService } from '../_services/index';

declare var $: any;
declare var google: any;
declare var jQuery: any;
declare var REP: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'package.component.html',
    styleUrls: ['package.component.css']
})
export class PackageComponent implements OnInit {
    public searchAddress: any;
    googleMapType = 'roadmap';
    currentUser: User;
    users: User[] = [];
    pacData: any;
    proData: any;
    dataSourcesData: any;
    selectedPac: any;
    selectedPro = [];
    selectedRpt = [];
    SelectedDataSource = [];
    SelectedDataSourceCode = [];
    packageAll = [];
    StreetNo: string;
    Street: string;
    address: string;
    editAddress = "";
    editCity = '';
    country: string;
    provstate: string;
    desArray = []; //production selected item
    rptSelectedArray = [];//report selected item
    proSelectedArray = [];//product selected item
    mapToggle = "small";
    pacToggle = "small";
    items: any;
    values: any;
    savedPackageAll = [];
    btnText = "";
    collapseBthText = '<i class="fa fa-minus-square-o"></i>';
    username = "Username";
    selectedRadius: any;
    selectedBaseRadius: string;
    bufferPoly: any;
    selectedRadiusPlus = 0;
    map1: any;
    Center1: any;
    highlightArea: string;
    savedGeoLayer: any;
    savedType: string;
    savedMultiGeoLayer = [];
    currentCode = "";
    currentMax = "";
    companyname = "";
    xReqCode = [];
    xReqName = [];
    fimReqName = [];
    fimReqCode = [];
    vaporReqName = [];
    vaporReqCode = [];
    fimAvai: any;
    codeArray = [];
    typeArray = [];
    OBMArray = [];
    OBMFlag = "Y";
    geoBuffer: any;
    savedBuffer: string;
    savedBufferUnit: string;
    unchange: string;
    permitInfo: any;
    permitAddress = "";
    permitCity = "";
    uploadedFile = "";
    sizeText: string;
    customerCount = 0;
    standardCount = 0;
    parceIds = [];
    constructor(private router: Router, private ngZone: NgZone, private userService: UserService, private cookieService: CookieService, private packageService: PackageService, private productService: ProductService, private datasourcesService: DataSourcesService,
        private introService: IntroService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
    }

    getPackages(customerId: string, provstate: string, country: string, type: string, size: number, skey: string, isEnvelope: string = "N"): void {
        this.packageService.getpackages(customerId, provstate, country, type, size, skey, isEnvelope).subscribe(pacData => {
            this.pacData = pacData;
            let totalPackage = [];
            if (this.pacData.length == 0) {
                $("#productTab").trigger("click");
            } else {
                for (let pac of this.pacData) {
                    if (pac.TYPE == 'Custom') {
                        this.customerCount++;
                    } else {
                        this.standardCount++;
                    }
                    totalPackage.push(pac.PACKAGE_CODE);
                }
                if (this.customerCount == 0) {
                    $("#customePacArea").css("display", "none");
                    if ((country != "Mexico") && (country != "MEX") && (this.standardCount == 0)) {
                        $("#productTab").trigger("click");
                    } else {
                        $("#pacPanel").css('display', 'block');
                    }
                    if ((country == 'Canada') || (country == "CAN")) {
                        $("#productTab").trigger("click");
                    }
                }
            }
            if (this.cookieService.getCookie('Order')) {
                if ((this.cookieService.getCookie('Package')) && (this.cookieService.getCookie('PackageAll'))) {
                    this.selectedPac = JSON.parse(this.cookieService.getCookie('Package'));
                    if (this.selectedPac) {
                        if (totalPackage.indexOf(this.selectedPac.PACKAGE_CODE) != -1) {
                            this.packageAll = JSON.parse(this.cookieService.getCookie('PackageAll'));
                            if (this.packageAll) {
                                for (let pac of this.packageAll) {
                                    this.savedPackageAll.push(pac.proP.PRODUCT_CODE);
                                    if (pac.checked == "true") {
                                        this.desArray.push(pac.proP.PRODUCT_NAME);
                                    }
                                }
                            }
                        } else {
                            this.packageAll = [];
                            this.desArray = [];
                            this.savedPackageAll = [];
                            this.selectedPac = [];
                            this.cookieService.setCookieSession('Package', JSON.stringify(this.selectedPac))
                            this.cookieService.setCookieSession('PackageAll', JSON.stringify(this.packageAll))
                        }
                    }
                }
                return;
            }

            if (this.cookieService.getCookie('savedOrder')) {
                let orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
                let savedPac: any;
                let savedPacProId = [];
                let savedPacPro = [];
                if (orderInfo) {
                    for (let pro of orderInfo.products) {
                        if (pro.package_oid != "") {
                            for (let pac of this.pacData) {
                                if (pac.PACKAGE_OID == pro.package_oid) {
                                    this.cookieService.setCookieSession("Package", JSON.stringify(pac));
                                    this.selectedPac = pac;
                                    savedPac = pac;
                                }
                            }
                        }
                    }
                    let allPacPro = [];
                    let allPacProId = [];
                    if (savedPac) {
                        for (let ppro of savedPac.PRODUCTS) {
                            allPacPro.push(ppro);
                            allPacProId.push(ppro.PRODUCT_CODE);
                        }

                        for (let pro of orderInfo.products) {
                            if (pro.package_oid != "") {
                                let index = allPacProId.indexOf(pro.product_code);
                                if (index != -1) {
                                    let ppro = allPacPro[index];
                                    let timeLineKeys = [];
                                    let timeLineValue = [];
                                    let radiusKeys = [];
                                    let radiusValue = [];
                                    let plusKeys = [];
                                    let plusValue = [];
                                    let required = [];
                                    let OPTA = [];
                                    let COT = [];
                                    let LTS = [];
                                    let YEAR = [];
                                    let COMM = '';
                                    let NEPA = "";
                                    let Other = "";
                                    let allReq = ppro.REQUIRED_FIELDS;

                                    for (let req of allReq) {
                                        if (req.TYPE == "Delivery") {
                                            timeLineKeys = Object.keys(req.OPTIONS);
                                            for (let key of timeLineKeys) {
                                                timeLineValue.push(req.OPTIONS[key])
                                            }
                                            required.push("timeline");
                                        } else if (req.TYPE == "Search Distance") {
                                            radiusKeys = Object.keys(req.OPTIONS.SEARCH_DISTANCE);
                                            for (let key of radiusKeys) {
                                                radiusValue.push(req.OPTIONS.SEARCH_DISTANCE[key])
                                            }
                                            plusKeys = Object.keys(req.OPTIONS.SEARCH_RADIUS);
                                            for (let key of plusKeys) {
                                                plusValue.push(req.OPTIONS.SEARCH_RADIUS[key])
                                            }
                                            required.push("radius");
                                        } else if (req.TYPE == "CD Extra") {
                                            required.push("CD");
                                        } else if (req.TYPE == "COT Extra") {
                                            required.push("COT");
                                            if (pro.input !== null) {
                                                COT = pro.input;
                                            } else {
                                                COT = [];
                                            }
                                        } else if (req.TYPE == "OPTA Extra") {
                                            required.push("OPTA");
                                            if (pro.input !== null) {
                                                OPTA = pro.input;
                                            } else {
                                                OPTA = [];
                                            }
                                        } else if (req.TYPE == "LTS Extra") {
                                            required.push("LTS");
                                            if (pro.input !== null) {
                                                LTS = pro.input;
                                            } else {
                                                LTS = [];
                                            }
                                        } else if ((req.TYPE == "comment") && (required.indexOf('YEAR') == -1)&&pro.product_code!="CDS_9"&&pro.product_code!="CDS_11"&&pro.product_code!="CDS_8"&&pro.product_code!="NEPA_US1"&&pro.product_code!="NEPA_US2"){
                                            required.push("COMM");
                                            if (pro.input) COMM = pro.input[0];
                                        }else if(pro.product_code=="CDS_9"||pro.product_code=="CDS_11"||pro.product_code=="CDS_8"||pro.product_code=="NEPA_US1"||pro.product_code=="NEPA_US2"){
                                            if(pro.comment&&pro.comment.length>0){
                                                COMM = pro.comment;
                                            }
                                        }
                                        else if (req.TYPE == "PERMIT Extra" || req.TYPE == "PROPERTY DETAIL Extra") {
                                            required.push("PERMIT");
                                            if (pro.input !== null) {
                                                Other = pro.input[0];
                                                this.permitInfo = Other;
                                                let array = this.permitInfo.split(",");
                                                this.permitAddress = array[0];
                                                this.permitCity = array[1];
                                            } else {
                                                Other = "";
                                            }
                                        } else if (req.TYPE == "CAN AERIAL Extra") {
                                            required.push("YEAR");
                                            if (pro.input !== null) {
                                                YEAR = pro.input;
                                            } else {
                                                YEAR = [];
                                            }
                                            if (pro.comment !== null) {
                                                COMM = pro.comment;
                                            } else {
                                                COMM = "";
                                            }
                                        } else if (req.TYPE == "NEPA Extra") {
                                            required.push("NEPA");
                                            if (pro.input !== null) {
                                                NEPA = pro.input;
                                            } else {
                                                NEPA = "";
                                            }
                                        }
                                    }

                                    let textBox = orderInfo.search_radius_increase;
                                    let plusIndex = plusValue.indexOf(Number(textBox));
                                    let pluskey = plusKeys[plusIndex];
                                    let proP = ppro;
                                    $("#" + proP.PRODUCT_CODE).prop("checked", true);
                                    let timeLine = pro.turnaround;
                                    let timeLineIndex = timeLineValue.indexOf(timeLine);
                                    let timeLinekey = timeLineKeys[timeLineIndex];
                                    let radius = orderInfo.distance_code;
                                    let radiusIndex = radiusValue.indexOf(radius);
                                    let radiuskey = radiusKeys[radiusIndex];
                                    let CD = pro.city_directory_street;

                                    let year = pro.inpup
                                    if (ppro.DATASOURCE == "Y") {
                                        required.push("source");
                                    }

                                    let pacProInfo: any;

                                    pacProInfo = { "proP": proP, "checked": "true", "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, 'YEAR': YEAR, 'NEPA': NEPA, 'COMM': COMM, 'required': required, 'Other': Other }

                                    savedPacPro.push(pacProInfo);

                                    this.savedPackageAll.push(proP.PRODUCT_CODE);
                                    this.desArray.push(proP.PRODUCT_NAME);
                                }
                            }
                        }

                        this.packageAll = savedPacPro;
                        if ((this.selectedPac) && (this.packageAll.length != 0)) {
                            this.cookieService.setCookieSession('Package', JSON.stringify(this.selectedPac));
                            this.cookieService.setCookieSession('PackageAll', JSON.stringify(this.packageAll));
                        }
                    }
                }
            }
        });
    }

    getProducts(country: string, provState: string, customerId: string, type: string, size: number, skey: string): void {
        this.productService.getproducts(country, provState, customerId, type, size, skey).subscribe(proData => {
            this.items = proData;
            if (this.cookieService.getCookie('Order')) {
                let allReport = [];
                let allProduct = [];
                let keys = Object.keys(proData);
                for (let key of keys) {

                    if (key != "Database Report") {
                        for (let pro of proData[key].PRODUCTS) {
                            allProduct.push(pro.PRODUCT_CODE)
                        }
                    } else {
                        for (let rpt of proData[key].PRODUCTS) {
                            allReport.push(rpt.PRODUCT_CODE);
                        }
                    }
                }
                if (this.cookieService.getCookie('Report')) {
                    let selRpt = JSON.parse(this.cookieService.getCookie('Report'));
                    let rpt = selRpt;
                    for (let i = 0; i < selRpt.length; i++) {
                        if (allReport.indexOf(selRpt[i].Srpt.PRODUCT_CODE) != -1) {
                            this.rptSelectedArray.push(selRpt[i].Srpt.PRODUCT_NAME);
                        } else {
                            rpt.splice(i, 1);
                        }
                    }

                    this.selectedRpt = rpt;
                }
                if (this.cookieService.getCookie('Product')) {
                    let selPro = JSON.parse(this.cookieService.getCookie('Product'));
                    let pro = selPro;
                    for (let i = 0; i < selPro.length; i++) {
                        if (allProduct.indexOf(selPro[i].Spro.PRODUCT_CODE) != -1) {
                            this.proSelectedArray.push(selPro[i].Spro.PRODUCT_NAME);
                        } else {
                            pro.splice(i, 1);
                        }
                        this.proSelectedArray.push(selPro[i].Spro.PRODUCT_NAME);
                    }

                    this.selectedPro = pro;
                }
                return;
            }
            if (this.cookieService.getCookie('savedOrder')) {
                let orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
                if (orderInfo) {
                    let proId = [];
                    let allPro = [];
                    let rptId = [];
                    let allrpt = [];
                    let proMulti = [];
                    let rptMulti = [];
                    let proTitle = [];
                    let rptTitle = [];
                    let keyArray = Object.keys(this.items);

                    for (let i = 0; i < keyArray.length; i++) {
                        ;
                        let products = this.items[keyArray[i]].PRODUCTS;
                        for (let pro of products) {
                            if (pro.TYPE == 'product') {
                                allPro.push(pro);
                                proId.push(pro.PRODUCT_CODE);
                                proMulti.push(this.items[keyArray[i]].IS_MULTI_SELECT);
                                proTitle.push(keyArray[i][0] + i);
                            } else if (pro.TYPE == 'report') {
                                rptId.push(pro.PRODUCT_CODE);
                                allrpt.push(pro);
                                rptMulti.push(this.items[keyArray[i]].IS_MULTI_SELECT);
                                rptTitle.push(keyArray[i][0] + i);
                            }
                        }
                    }
                    let savedPro = [];
                    let savedRpt = [];

                    for (let pro of orderInfo.products) {

                        if (pro.package_oid == "") {

                            if (pro.type == "product") {
                                let index = proId.indexOf(pro.product_code);
                                if (index != -1) {
                                    let timeLineKeys = [];
                                    let timeLineValue = [];
                                    let radiusKeys = [];
                                    let radiusValue = [];
                                    let plusKeys = [];
                                    let plusValue = [];
                                    let required = [];
                                    let comm = "";
                                    let OPTA = [];
                                    let LTS = [];
                                    let COT = [];
                                    let YEAR = [];
                                    let Other = "";
                                    let NEPA = "";
                                    let proP = allPro[index];
                                    if (proP.DATASOURCE == "Y") {
                                        required.push("source");
                                    }
                                    let allReq = proP.REQUIRED_FIELDS;
                                    for (let req of allReq) {
                                        if (req.TYPE == "Delivery") {
                                            timeLineKeys = Object.keys(req.OPTIONS);
                                            for (let key of timeLineKeys) {
                                                timeLineValue.push(req.OPTIONS[key])
                                            }
                                            required.push("timeline");
                                        } else if (req.TYPE == "Search Distance") {

                                            required.push("radius");
                                        } else if (req.TYPE == "CD Extra") {
                                            required.push("CD");
                                        } else if (req.TYPE == "COT Extra") {
                                            required.push("COT");
                                            if (pro.input !== null) {
                                                COT = pro.input;
                                            } else {
                                                COT = [];
                                            }
                                        } else if (req.TYPE == "OPTA Extra") {
                                            required.push("OPTA");
                                            if (pro.input !== null) {
                                                OPTA = pro.input;
                                            } else {
                                                OPTA = [];
                                            }
                                        } else if (req.TYPE == "LTS Extra") {
                                            required.push("LTS");
                                            if (pro.input !== null) {
                                                LTS = pro.input;
                                            } else {
                                                LTS = [];
                                            }
                                        } else if ((req.TYPE == "comment") && (required.indexOf('YEAR') == -1)&&pro.product_code!="CDS_9"&&pro.product_code!="CDS_11"&&pro.product_code!="CDS_8"&&pro.product_code!="NEPA_US1"&&pro.product_code!="NEPA_US2"){
                                            required.push("COMM");
                                            if (pro.input) comm = pro.input[0];
                                        }else if(pro.product_code=="CDS_9"||pro.product_code=="CDS_11"||pro.product_code=="CDS_8"||pro.product_code=="NEPA_US1"||pro.product_code=="NEPA_US2"){
                                            if(pro.comment&&pro.comment.length>0){
                                                comm = pro.comment;
                                            }
                                        }else if (req.TYPE == "PERMIT Extra" || req.TYPE == "PROPERTY DETAIL Extra") {
                                            required.push("PERMIT");
                                            if (pro.input !== null) {
                                                Other = pro.input[0];
                                                this.permitInfo = Other;
                                                let array = this.permitInfo.split(",");
                                                this.permitAddress = array[0];
                                                this.permitCity = array[1];
                                            } else {
                                                Other = "";
                                            }
                                        } else if (req.TYPE == "CAN AERIAL Extra") {
                                            required.push("YEAR");
                                            if (pro.input !== null) {
                                                YEAR = pro.input;
                                            } else {
                                                YEAR = [];
                                            }
                                            if (pro.comment !== null) {
                                                comm = pro.comment;
                                            }
                                        } else if (req.TYPE == "NEPA Extra") {
                                            required.push("NEPA");
                                            if (pro.input !== null) {
                                                NEPA = pro.input;
                                            } else {
                                                NEPA = "";
                                            }
                                        }
                                    }
                                    let timeLine = pro.turnaround;
                                    let timeLineIndex = timeLineValue.indexOf(timeLine);
                                    let timeLinekey = timeLineKeys[timeLineIndex];
                                    let title = proTitle[index];
                                    let radius = "";

                                    let radiuskey = "";
                                    let textBox = "";

                                    let pluskey = "";
                                    let CD = pro.city_directory_street;
                                    let multi = proMulti[index];
                                    let proInfo = { "Spro": proP, "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "title": title, "CD": CD, "COT": COT, "OPTA": OPTA, 'LTS': LTS, "COMM": comm, 'YEAR': YEAR, 'NEPA': NEPA, "multi": multi, "required": required, 'Other': Other };
                                    savedPro.push(proInfo);
                                    this.proSelectedArray.push(proP.PRODUCT_NAME);
                                }
                            } else if (pro.type == "report") {
                                let index = rptId.indexOf(pro.product_code);
                                if (index != -1) {
                                    let timeLineKeys = [];
                                    let timeLineValue = [];
                                    let radiusKeys = [];
                                    let radiusValue = [];
                                    let plusKeys = [];
                                    let plusValue = [];
                                    let required = [];
                                    let comm = "";
                                    let rpt = allrpt[index];
                                    let allReq = rpt.REQUIRED_FIELDS;
                                    for (let req of allReq) {
                                        if (req.TYPE == "Delivery") {
                                            timeLineKeys = Object.keys(req.OPTIONS);
                                            for (let key of timeLineKeys) {
                                                timeLineValue.push(req.OPTIONS[key])
                                            }
                                            required.push("timeline");
                                        } else if (req.TYPE == "Search Distance") {
                                            radiusKeys = Object.keys(req.OPTIONS.SEARCH_DISTANCE);
                                            for (let key of radiusKeys) {
                                                radiusValue.push(req.OPTIONS.SEARCH_DISTANCE[key])
                                            }
                                            plusKeys = Object.keys(req.OPTIONS.SEARCH_RADIUS);
                                            for (let key of plusKeys) {
                                                plusValue.push(req.OPTIONS.SEARCH_RADIUS[key])
                                            }
                                            required.push("radius");
                                        } else if (req.TYPE == "CD Extra") {
                                            required.push("CD");
                                        } else if (req.TYPE == "COT Extra") {
                                            required.push("COT");
                                        } else if (req.TYPE == "OPTA Extra") {
                                            required.push("OPTA");
                                        } else if (req.TYPE == "LTS Extra") {
                                            required.push("LTS");
                                        } else if (req.TYPE == "comment") {
                                            if (pro.input) comm = pro.input[0];
                                        }
                                        else if (req.TYPE == "buffersize") {
                                            required.push("Buffer");
                                        }
                                    }

                                    let timeLine = pro.turnaround;
                                    let timeLineIndex = timeLineValue.indexOf(timeLine);
                                    let timeLinekey = timeLineKeys[timeLineIndex];
                                    let radius = orderInfo.distance_code;
                                    let radiusIndex = radiusValue.indexOf(radius);
                                    let radiuskey = radiusKeys[radiusIndex];
                                    let textBox = orderInfo.search_radius_increase;
                                    let pluskey = "";
                                    if (textBox != "") {
                                        let plusIndex = plusValue.indexOf(Number(textBox));
                                        pluskey = plusKeys[plusIndex];
                                    }

                                    let CD = [];
                                    let COT = [];
                                    let OPTA = [];
                                    let LTS = [];
                                    let multi = rptMulti[index];
                                    let title = rptTitle[index];;
                                    let rptInfo: any;
                                    if (rpt.DATASOURCE == "Y") {
                                        if (radius.length == 0) required.push("source");
                                    }
                                    if (pro.buffer_size) {
                                        rptInfo = { "Srpt": rpt, "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "title": title, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, "COMM": comm, "multi": multi, "required": required, "Buffer": pro.buffer_size };
                                        this.savedBuffer = pro.buffer_size;

                                        if ((this.savedBuffer) && (this.savedBufferUnit) && (this.cookieService.getCookie('selectedGeometry')) && (this.cookieService.getCookie('geoType'))) {
                                            let geom = this.cookieService.getCookie('selectedGeometry');
                                            let geoType = this.cookieService.getCookie('geoType');
                                            let sKey = this.cookieService.getCookie("sessionKey");
                                            let customerId = this.cookieService.getCookie('customerID');
                                            let type: string;
                                            if (geoType == "POINT") {
                                                type = "centre";
                                            } else if (geoType == "polyline") {
                                                geoType = "POLYLINE";
                                                type = "edge";
                                            } else if (geoType == "polygon") {
                                                geoType = "POLYGON";
                                                type = "edge";
                                            }
                                            if (this.savedBufferUnit == "meters") {
                                                this.savedBufferUnit = "metres";
                                            } else if (this.savedBufferUnit == "miles") {
                                                this.savedBufferUnit = "mile";
                                            }
                                            let geometry = this.cookieService.getCookie('selectedGeometry');
                                            this.getGeoBuffer(customerId, geom, this.savedBuffer, this.savedBufferUnit, type, geoType, sKey);
                                        }
                                    } else {
                                        rptInfo = { "Srpt": rpt, "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "title": title, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, "COMM": comm, "multi": multi, "required": required };
                                    }

                                    savedRpt.push(rptInfo);
                                    this.rptSelectedArray.push(rpt.PRODUCT_NAME);
                                }
                            }
                        }
                        this.selectedPro = savedPro;
                        this.selectedRpt = savedRpt;
                        if (this.selectedPro) {
                            this.cookieService.setCookieSession('Product', JSON.stringify(this.selectedPro));
                        }
                        if (this.selectedRpt) {
                            this.cookieService.setCookieSession('Report', JSON.stringify(this.selectedRpt));
                        }
                    }
                }
            }
        });
    }

    getDatasources(customerId: string, country: string, provstate: string, skey: string): void {
        this.datasourcesService.getdataSources(customerId, country, provstate, skey).subscribe(dataSourcesData => {
            this.dataSourcesData = dataSourcesData;

            if (this.cookieService.getCookie('Order')) {

                return;
            }
            if (this.cookieService.getCookie('savedOrder')) {
                let orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
                if (orderInfo) {
                    this.SelectedDataSourceCode = [];
                    this.SelectedDataSource = [];
                    for (let sourceCode of orderInfo.data_sources) {
                        let keys = Object.keys(dataSourcesData);
                        for (let key of keys) {
                            let source = dataSourcesData[key];
                            for (let item of source) {
                                if (item.DS_OID == sourceCode) {
                                    this.SelectedDataSource.push(item.NAME);
                                }
                            }
                        }
                        this.SelectedDataSourceCode.push(sourceCode);
                    }
                }
            }
        });
    }
    getReqList(customerId: string, companyId: string, country: string, skey: string): void {
        this.productService.getxplorerReq(customerId, companyId, country, skey).subscribe(data => {
            let eriskey = (Object.keys(data))[0];
            let xReq = data[eriskey];
            if (xReq) {
                this.xReqName = Object.keys(xReq);
                this.xReqCode = [];
                for (let name of this.xReqName) {
                    if (name != "Fire Insurance Maps") {
                        this.xReqCode = this.xReqCode.concat(xReq[name].split(","));
                    } else {
                        this.fimAvai = (xReq[name]).FIM_2;
                    }
                }
            }


            let fimkey = (Object.keys(data))[1];
            let fimReq = data[fimkey];
            if (fimReq) {
                this.fimReqName = Object.keys(fimReq);
                this.fimReqCode = [];
                for (let name of this.fimReqName) {
                    this.fimReqCode = this.fimReqCode.concat(fimReq[name].split(","));
                }
            }

            let vaporReq = data.Vapor;
            if (vaporReq) {
                this.vaporReqName = Object.keys(vaporReq);
                for (let name of this.vaporReqName) {
                    this.vaporReqCode = this.vaporReqCode.concat(vaporReq[name].split(","));
                }
            }
        });
    }

    getGeoBuffer(customerId: string, geometry: string, radius: string, unit: string, type: string, geoType: string, skey: string): void {
        this.productService.getbuffer(customerId, geometry, radius, unit, type, geoType, skey).subscribe(data => {

            let bufferArray = [];
            if (data.length > 0) {
                for (let i = 0; i < data[0].length; i++) {
                    let pointJson = { lat: data[0][i][1], lng: data[0][i][0] };
                    bufferArray.push(pointJson);
                }

                if (this.geoBuffer && this.geoBuffer.setMap) this.geoBuffer.setMap(null);
                this.geoBuffer = new google.maps.Polygon({
                    paths: bufferArray,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: 'rgb(195,212,47)',
                    fillOpacity: 0.45,
                    clickable: false,
                    map: this.map1
                });
            }
        });
    }

    ngOnInit() {
        if (!this.cookieService.getCookie('customerID')) {
            return;
        }
        let parcelInfoWindow;
        let totalRequested = 0;
        let searchIw;
        let mapFeatures = [];
        let savedGeoType;
        let searchmarker;
        let Center;

        this.sizeText = "";
        this.introService.setPackageOptions();
        if (this.cookieService.getCookie('parceIds')) {
            this.parceIds = JSON.parse(this.cookieService.getCookie('parceIds'));
        }
        if (this.cookieService.getCookie('StreetNo')) {
            this.StreetNo = this.cookieService.getCookie('StreetNo');
        }
        if (this.cookieService.getCookie('Street')) {
            this.Street = this.cookieService.getCookie('Street');
        }
        if (this.cookieService.getCookie('customerName')) {
            this.username = this.cookieService.getCookie('customerName');
        }
        if (this.cookieService.getCookie('companyName')) {
            this.companyname = this.cookieService.getCookie('companyName');
        }
        if ((this.cookieService.getCookie('selectedGeometry')) && (this.cookieService.getCookie('geoType'))) {

            savedGeoType = this.cookieService.getCookie('geoType');
            let Geom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));


            let savedGeom = Geom[0];
            let savedGeom1 = [];
            for (let i = 0; i < savedGeom.length; i++) {
                let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                savedGeom1.push(pointJson);
            }
            Center = savedGeom1[0];
        } else {
            Center = new google.maps.LatLng(39.5673692, -103.6296376);
        }

        this.Center1 = Center;
        let Zoom = 16;

        if (this.cookieService.getCookie('DataSources')) {
            this.SelectedDataSource = JSON.parse(this.cookieService.getCookie('DataSources'));
        }
        if (this.cookieService.getCookie('DataSourcesCode')) {
            this.SelectedDataSourceCode = JSON.parse(this.cookieService.getCookie('DataSourcesCode'));
        }

        let el = document.getElementById("googleMapsmall");
        let e2 = document.getElementById("searchMap");
        let that = this;
        if (this.cookieService.getCookie('SATVIEW') == 'Y') {
            that.googleMapType = 'satellite';
        }

        let mapOp = {
            center: Center,
            controlSize: 24,
            zoom: Zoom - 2,
            scaleControl: true,
            fullscreenControl: false,
            mapTypeId: that.googleMapType,
            styles: [{
                "featureType": "poi", "stylers": [{ "visibility": "off" },
                {
                    'featureType': 'transit',
                    'elementType': 'labels.icon',
                    'stylers': [{ visibility: 'off' }]
                }]
            }],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
        };
        let mapOp2 = {
            center: Center,
            zoom: Zoom,
            controlSize: 24,
            scaleControl: true,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{
                "featureType": "poi", "stylers": [{ "visibility": "off" },
                {
                    'featureType': 'transit',
                    'elementType': 'labels.icon',
                    'stylers': [{ visibility: 'off' }]
                }]
            }],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
        };

        let map = new google.maps.Map(el, mapOp);
        if (this.cookieService.getCookie('SATVIEW') == 'Y') {
            map.setTilt(45);
        }

        let map2 = new google.maps.Map(e2, mapOp2);
        if (REP) {
            if (Zoom >= 17) {
                REP.Layer.Google.Initialize(map2);
            }
        }

        $('#mapModal').on('shown.bs.modal', function () {
            google.maps.event.trigger(map2, "resize");
            map2.setCenter(Center);
        });
        this.map1 = map;
        let icon = {
            url: "assets/images/Site_Marker.png",
            scaledSize: new google.maps.Size(60, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(30, 40)
        };

        if (this.cookieService.getCookie('UplaodFileName')) {
            this.uploadedFile = this.cookieService.getCookie('UplaodFileName');
        }
        let geomArea = 0;
        let geomLength = 0;
        if ((this.cookieService.getCookie('selectedGeometry')) && (this.cookieService.getCookie('geoType'))) {
            savedGeoType = this.cookieService.getCookie('geoType');
            if (this.cookieService.getCookie('geoType') == "kml") {
                let fileUrl = this.cookieService.getCookie("UplaodGeometryFilelocation");
                let kmlLayer = new google.maps.KmlLayer({
                    url: fileUrl,
                    suppressInfoWindows: true,
                    map: map,
                });
            } else {
                let Geom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));

                if (Geom.length > 1) {
                    for (let geom of Geom) {
                        let savedGeom = geom;
                        let savedGeom1 = [];
                        for (let i = 0; i < savedGeom.length; i++) {
                            let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                            savedGeom1.push(pointJson);
                        }


                        let geoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            map: map
                        });
                        geomArea += Math.round(google.maps.geometry.spherical.computeArea(geoLayer.getPath())); google.maps.geometry.spherical.computeArea(geoLayer.getPath());
                        this.savedMultiGeoLayer.push(geoLayer);
                    }
                } else {
                    let savedGeom = Geom[0];
                    let savedGeom1 = [];
                    for (let i = 0; i < savedGeom.length; i++) {
                        let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                        savedGeom1.push(pointJson);
                    }

                    if (savedGeoType == "polygon") {
                        this.savedGeoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            clickable: false,
                            map: map
                        });
                        geomArea = Math.round(google.maps.geometry.spherical.computeArea(this.savedGeoLayer.getPath()));
                    } else if (savedGeoType == "polyline") {
                        this.savedGeoLayer = new google.maps.Polyline({
                            path: savedGeom1,
                            geodesic: true,
                            strokeColor: '#000',
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                            map: map
                        });

                        geomArea = Math.round(google.maps.geometry.spherical.computeLength(this.savedGeoLayer.getPath()));
                    } else if (savedGeoType == "POINT") {
                        this.savedGeoLayer = new google.maps.Marker({
                            position: savedGeom1[0],
                            icon: icon,
                            anchorPoint: new google.maps.Point(0, -25),
                            map: map,
                        });
                        geomArea = 0;
                    }
                }
            }
        } else {
            this.cookieService.deleteCookie('selectedGeometry');
            this.cookieService.deleteCookie('geoType');
        }

        google.maps.event.addListener(map, 'click', function () {
            let bigBox = document.getElementById("textArea");
            let reportBox = document.getElementById("reportArea");
            let box = document.getElementById("bigMapBox");
            if (this.mapToggle == "small") {
                box.className = "col-md-12";
                el.style.height = "400px";
                el.style.width = "100%";
                bigBox.style.display = "none";
                reportBox.style.display = "none";
                google.maps.event.trigger(map, 'resize');
                map.setCenter(Center);
                map.setZoom(Zoom - 1);
                this.mapToggle = "big";
                document.getElementById("close_text").style.display = "block";
                document.getElementById("open_text").style.display = "none";
            } else {
                box.className = "col-md-6";
                el.style.height = "160px";
                el.style.width = "100%";
                bigBox.style.display = "block";
                reportBox.style.display = "block";
                google.maps.event.trigger(map, 'resize');
                map.setCenter(Center);
                map.setZoom(Zoom - 2);
                this.mapToggle = "small";
                document.getElementById("close_text").style.display = "none";
                document.getElementById("open_text").style.display = "block";
            }
        });

        if (REP) {
            google.maps.event.addListener(map2, 'zoom_changed', function (event) {
                let currentZoom = map2.getZoom();
                if (currentZoom >= 18) {
                    REP.Layer.Google.Initialize(map2);
                } else {
                    if (parcelInfoWindow) {
                        parcelInfoWindow.close();
                    }
                    map2.overlayMapTypes.clear();
                }
            })

            google.maps.event.addListener(map2, 'dblclick', function (event) {
                map2.set("disableDoubleClickZoom", true);

                if (map2.getZoom() < 18) return;
                let latLng = event.latLng;
                for (let i = 0; i < mapFeatures.length; i++) mapFeatures[i].setMap(null);
                mapFeatures = [];

                // Close any previous InfoWindow and hide any previous features.
                if (parcelInfoWindow) parcelInfoWindow.close();

                if (totalRequested > 19) {
                    let wInfo = 'Your parcel request exceed limit (20)!'
                    parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: wInfo });
                    parcelInfoWindow.open(map2);
                    return
                }

                REP.Layer.Google.IdentifyByPoint(map2, latLng, function (resp) {
                    let selectedGeom: any;
                    REP.Layer.IdentifyByPoint(map2, latLng.lng(), latLng.lat(), function (respJson) {
                        for (let i = 0; i < respJson.results.length; i++) {
                            let respRowI = respJson.results[i];

                            if (typeof (respRowI['geom_as_wkt']) !== 'undefined') {
                                selectedGeom = respRowI['geom_as_wkt'];
                            }
                        }
                    });

                    let wText = '';
                    if (resp.results.length) {
                        totalRequested++;
                        let respRow0 = resp.results[0];
                        for (let respKey in respRow0) {
                            let respVal = respRow0[respKey];
                            if (respVal === null) continue;
                            if (respKey === 'geom') {


                                for (let i = 0; i < respVal.length; i++) {
                                    respVal[i].setOptions({ fillColor: 'rgb(195,212,47)', fillOpacity: 0.65, strokeColor: 'rgb(195,212,47)', clickable: false });
                                    respVal[i].setMap(map2);
                                }
                                mapFeatures = respVal;
                            } else {
                                let parId = respRow0['parcel_id'];
                                if (parId == null) {
                                    parId = "";
                                }
                                let addrNo = respRow0['addr_number'];
                                if (addrNo == null) {
                                    addrNo = "";
                                }
                                let addrStreet = respRow0['addr_street_name'];
                                if (addrStreet == null) {
                                    addrStreet = "";
                                }
                                let addrType = respRow0['addr_street_type'];
                                if (addrType == null) {
                                    addrType = "";
                                }
                                let addrCity = respRow0['muni_name'];
                                if (addrCity == null) {
                                    addrCity = "";
                                }
                                let addrState = respRow0['state_abbr'];
                                if (addrState == null) {
                                    addrState = "";
                                }
                                let addrZip = respRow0['census_zip'];
                                if (addrZip == null) {
                                    addrZip = "";
                                }
                                let addInfo = addrNo + " " + addrStreet + " " + addrType + " " + addrCity + " " + addrState + " " + addrZip;
                                let countryInfo = respRow0['county_name'];
                                if (countryInfo == null) {
                                    countryInfo = "";
                                }
                                let ownerInfo = respRow0['owner'];
                                if (ownerInfo == null) {
                                    ownerInfo = "";
                                }
                                let landUseInfo = respRow0['land_use_class'];
                                if (landUseInfo == null) {
                                    landUseInfo = "";
                                }
                                let areaInfo = respRow0['area_meters'];
                                if (areaInfo == null) {
                                    areaInfo = "";
                                }
                                let perimeterInfo = respRow0['perimeter_meters'];
                                if (perimeterInfo == null) {
                                    perimeterInfo = "";
                                }
                                let acreInfo = respRow0['acreage_calc'];
                                if (acreInfo == null) {
                                    acreInfo = "";
                                }
                                wText = "<strong>Parcel ID: </strong>" + parId + "<br>" + "<strong>Address: </strong>" + addInfo + "<br>" + "<strong>County: </strong>" + countryInfo + '<br>' + "<strong>Owner: </strong>" + ownerInfo + '<br>' + "<strong>Land use class: </strong>" + landUseInfo + '<br>' + "<strong>Acreage: </strong>" + acreInfo + " acres";
                            }
                        }
                        if (searchIw) {
                            searchIw.setMap(null);
                        }
                        parcelInfoWindow = new google.maps.InfoWindow({ position: latLng, content: '<div id="infoContent" style=\"width:200px; height:200px\">' + wText + "</div>" });
                        parcelInfoWindow.open(map2);
                    }
                }, function (errObj) {
                    alert('REP Overlays error: ' + errObj.message);
                });
            });
        }

        let orderInfo: any
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'));
        } else if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        }
        if(this.cookieService.getCookie('orderPin')=='Y'&&orderInfo.order_pin){
            let pinGeom=JSON.parse(orderInfo.order_pin)[0][0];
            let position={lat:pinGeom[1], lng:pinGeom[0] }
            let pinMarker = new google.maps.Marker({
                position: position,
                map: map,
            });
        }
        this.address = orderInfo.provstate + ", " + orderInfo.postalzip + ", " + orderInfo.country;
        this.editCity = orderInfo.city;
        this.unchange = orderInfo.provstate + " " + orderInfo.postalzip;

        if (this.cookieService.getCookie('userInput')) {
            this.editAddress = "";
            let allAddress = this.cookieService.getCookie('userInput');
            let addressArray = allAddress.split(/[ ,]+/);
            let addressArray1 = allAddress.split(",");
            if ((!isNaN(Number(addressArray[0]))) && (!isNaN(Number(addressArray[1]))) && (addressArray.length == 2)) {
                this.editAddress = "";
            } else {
                this.editAddress = addressArray1[0].replace(/U002C/g, ",");;
            }
        }
        if (this.permitAddress == "") {
            this.permitAddress = this.editAddress;
        }

        if (this.permitCity == "") {
            this.permitCity = this.editCity;
        }
        this.country = orderInfo.country;
        this.provstate = orderInfo.provstate;

        let sessionKey = this.cookieService.getCookie("sessionKey");
        if (this.cookieService.getCookie('customerID')) {
            let ID = this.cookieService.getCookie('customerID');

            if ((this.country == "Canada") || (this.country == "CAN")) {
                this.country = "CAN";
                this.getProducts("CAN", this.provstate, ID, savedGeoType, geomArea, sessionKey);
            } else if ((this.country == "United States") || (this.country == "USA")) {
                this.getProducts("USA", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "USA";
                if (geomArea) {
                    let MgeomArea = Math.round(geomArea * 0.00024711 * 0.0015624989 * 1000000);
                    if (MgeomArea / 1000000 > 1) {
                        this.sizeText = "*The boundary size is over the standard threshold and may result in additional charges.  A Quote will be provided before the order is fulfilled."
                    }
                }
                if (savedGeoType == "polyline") {
                    this.sizeText = "*For Corridor sites, additional charges may be applied.  A Quote will be provided before the order is fulfilled."
                }
            } else if ((this.country == "Mexico") || (this.country == "MEX")) {
                this.getProducts("MEX", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "MEX";
                if (geomArea) {
                    let MgeomArea = Math.round(geomArea * 0.00024711 * 0.0015624989 * 1000000);
                    if (MgeomArea / 1000000 > 1) {
                        this.sizeText = "*The boundary size is over the standard threshold and may result in additional charges.  A Quote will be provided before the order is fulfilled."
                    }
                }
                if (savedGeoType == "polyline") {
                    this.sizeText = "*For Corridor sites, additional charges may be applied.  A Quote will be provided before the order is fulfilled."
                }
            } else if ((this.country == "United Kingdom") || (this.country == "UK")) {
                this.getProducts("UK", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "UK";
            } else if ((this.country == "Australia") || (this.country == "AUS")) {
                this.getProducts("AUS", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "AUS";
            } else if ((this.country == "Germany") || (this.country == "GER")) {
                this.getProducts("GER", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "GER";
            } else if ((this.country == "Argentina") || (this.country == "ARG")) {
                this.getProducts("ARG", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "ARG";
            } else if ((this.country == "Bahrain") || (this.country == "BRN")) {
                this.getProducts("BRN", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "BRN";
            } else if ((this.country == "Brazil") || (this.country == "BRA")) {
                this.getProducts("BRA", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "BRA";
            } else if ((this.country == "China") || (this.country == "CHN")) {
                this.getProducts("CHN", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "CHN";
            } else if ((this.country == "Colombia") || (this.country == "COL")) {
                this.getProducts("COL", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "COL";
            } else if ((this.country == "Costa Rica") || (this.country == "CRC")) {
                this.getProducts("CRC", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "CRC";
            } else if ((this.country == "France") || (this.country == "FRA")) {
                this.getProducts("FRA", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "FRA";
            } else if ((this.country == "Greece") || (this.country == "GRE")) {
                this.getProducts("GRE", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "GRE";
            } else if ((this.country == "India") || (this.country == "IND")) {
                this.getProducts("IND", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "IND";
            } else if ((this.country == "Japan") || (this.country == "JPN")) {
                this.getProducts("JPN", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "JPN";
            } else if ((this.country == "Kuwait") || (this.country == "KUW")) {
                this.getProducts("KUW", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "KUW";
            } else if ((this.country == "Luxembourg") || (this.country == "LUX")) {
                this.getProducts("LUX", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "LUX";
            } else if ((this.country == "Morocco") || (this.country == "MAR")) {
                this.getProducts("MAR", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "MAR";
            } else if ((this.country == "New Zealand") || (this.country == "NZL")) {
                this.getProducts("NZL", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "NZL";
            } else if ((this.country == "Philippines") || (this.country == "PHI")) {
                this.getProducts("PHI", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "PHI";
            } else if ((this.country == "Poland") || (this.country == "POL")) {
                this.getProducts("POL", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "POL";
            } else if ((this.country == "Romania") || (this.country == "ROU")) {
                this.getProducts("ROU", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "ROU";
            } else if ((this.country == "Saudi Arabia") || (this.country == "KSA")) {
                this.getProducts("KSA", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "KSA";
            } else if ((this.country == "Singapore") || (this.country == "SGP")) {
                this.getProducts("SGP", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "SGP";
            } else if ((this.country == "Spain") || (this.country == "ESP")) {
                this.getProducts("ESP", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "ESP";
            } else if ((this.country == "Sri Lanka") || (this.country == "SRI")) {
                this.getProducts("SRI", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "SRI";
            } else if ((this.country == "Switzerland") || (this.country == "SUI")) {
                this.getProducts("SUI", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "SUI";
            } else if ((this.country == "Turkey") || (this.country == "TUR")) {
                this.getProducts("TUR", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "TUR";
            } else if ((this.country == "United Arab Emirates") || (this.country == "UAE")) {
                this.getProducts("UAE", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "UAE";
            } else if ((this.country == "Vietnam") || (this.country == "VIE")) {
                this.getProducts("VIE", this.provstate, ID, savedGeoType, geomArea, sessionKey);
                this.country = "VIE";
            }

            let isEnvelope = this.cookieService.getCookie('isEnvelope') || "N";
            this.getPackages(ID, this.provstate, this.country, savedGeoType, geomArea, sessionKey, isEnvelope);

            this.getDatasources(ID, this.country, this.provstate, sessionKey);
            if (this.cookieService.getCookie('companyId')) {
                let companyId = this.cookieService.getCookie('companyId');
                this.getReqList(ID, companyId, this.country, sessionKey);
            }
        }

        initAutocomplete();
        $("#clear-selection").toggle(false);
        $("#packageTab").click(function () {
            $("#add-products").toggle(true);
        });
        $("#productTab").click(function () {
            $("#add-products").toggle(false);
        });

        function initAutocomplete() {
            let geocoder = new google.maps.Geocoder();
            jQuery("#search-button").on('click', function (e) {
                let inputValue = $("#search").val();
                if (inputValue != "") {
                    geocoder.geocode({ 'address': inputValue }, function (results) {
                        if (results.length == 0) {
                            return;
                        }
                        processGeocode(results);
                    })
                }
            })
            jQuery("#search").on('keypress', function (e) {
                if (e.type == 'keypress') {
                    let keycode = (e.keyCode ? e.keyCode : e.which);
                    if (keycode != '13') {
                        return
                    }
                }
                geocoder.geocode({ 'address': this.value }, function (results) {
                    if (results.length == 0) {
                        return;
                    }

                    processGeocode(results);
                });
            })

            function processGeocode(results) {
                let lat = results[0].geometry.location.lat();
                let lng = results[0].geometry.location.lng();
                map2.setCenter({ lat: lat, lng: lng });
                map2.setZoom(17);
                let streetNo, street: string;
                for (let i = 0; i < results[0].address_components.length; i++) {
                    if (results[0].address_components[i].types.indexOf("street_number") != -1) {
                        streetNo = results[0].address_components[i] && results[0].address_components[i].long_name;
                        $("#modalStreetNo").val(streetNo);
                    }
                    if (results[0].address_components[i].types.indexOf("street_address") != -1) {
                        street = results[0].address_components[i] && results[0].address_components[i].long_name;
                        $("#modalStreetName").val(street);
                    }
                    if (results[0].address_components[i].types.indexOf("route") != -1) {
                        street = results[0].address_components[i] && results[0].address_components[i].long_name;
                        $("#modalStreetName").val(street);
                    }
                }
                let Address1 = streetNo + " " + street;
                let address = (results[0].formatted_address);

                let icon = {
                    url: "assets/images/Site_Marker.png",
                    scaledSize: new google.maps.Size(60, 40), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    anchor: new google.maps.Point(30, 40)
                };
                if (searchmarker) {
                    searchmarker.setMap(null);
                }
                // Create a marker for each place.
                searchmarker = new google.maps.Marker({
                    map: map2,
                    icon: icon,
                    title: results[0].name,
                    draggable: true,
                    anchorPoint: new google.maps.Point(0, -25),
                    position: results[0].geometry.location
                });
                let searchContent = address;
                searchIw = new google.maps.InfoWindow({
                    position: results[0].geometry.location,
                    content: searchContent,
                    pixelOffset: new google.maps.Size(0, -25)
                });
                searchIw.open(map2);
            }
        }
    }

    pacOnSelection(pac, event): void {
        let hasParcels = false;
        let cotPara = [];
        $("#hisWarn").css('display', 'none');
        $("#editBtn").css("display", "inline");
        this.hideBuffer();
        //clear previous disabled item

        $('.package-div').each(function () {
            if ($(this).attr('id') !== $(event.target).closest('.package-div').attr('id')) $(this).toggle(false);
            else $(this).toggle(true);
        });
        $('#custom-title').toggle(false);
        $('#standard-title').toggle(false);
        $('#pacBtn').toggle(false);
        $("#clear-selection").toggle(true);

        this.cookieService.deleteCookie("Package");
        this.cookieService.deleteCookie("PackageAll");
        let other: any;
        if (this.selectedPac) {
            other = this.selectedPac;
            if (other.PRODUCTS) {
                for (let proP of other.PRODUCTS) {
                    $("#" + proP.PRODUCT_CODE).prop("checked", false);
                    $("#" + proP.PRODUCT_CODE).parents("label").next("span").css('display', 'inline');
                    if (document.getElementById(proP.PRODUCT_CODE)) {
                        document.getElementById(proP.PRODUCT_CODE).removeAttribute('disabled');
                    }
                }
            }
        }

        this.packageAll = [];
        this.SelectedDataSource = [];
        this.SelectedDataSourceCode = [];
        this.selectedPac = pac;
        $('.' + 'highlightArea').each(function () {
        });
        this.btnText = '<i class="fa fa-minus-square-o"></i>';
        let i = 0;
        let opt = [];
        for (let proP of pac.PRODUCTS) {
            let pacProInfo: any
            //*********reomve extra products and report selecpacPro Information*************
            //*********end of reomve extra products and report selection*************
            //*********add option part*************
            let allOpt = proP.REQUIRED_FIELDS;
            let timeLine = "";
            let CD = [];
            let COT = [];
            let OPTA = [];
            let LTS = [];
            let Other = "";
            let radius = "";
            let textBox = "";
            let COMM = "";
            let YEAR = [];
            let NEPA = "";
            let required = [];
            if (proP.DATASOURCE == "Y") {
                required.push("source");
            }
            if ((proP.MAPBUFFERSIZE != "") && (proP.MAPBUFFERUNIT != "")) {
                this.showBuffer(proP.MAPBUFFERUNIT, proP.MAPBUFFERSIZE);
            }
            let radiuskey = "";
            let timeLinekey = "";
            let pluskey = "";
            for (let opt of allOpt) {
                if (opt.TYPE == "Delivery") {
                    let keys = Object.keys(opt.OPTIONS);
                    keys = keys.filter(function (item) {
                        return item !== ''
                    })
                    timeLinekey = (keys)[0];
                    timeLine = opt.OPTIONS[timeLinekey];
                    required.push("timeline");
                } else if (opt.TYPE == "Search Distance") {
                    radiuskey = (Object.keys(opt.OPTIONS.SEARCH_DISTANCE))[0];
                    radius = (opt.OPTIONS.SEARCH_DISTANCE)[radiuskey];
                    this.selectedBaseRadius = radius;
                    required.push("radius");
                    if (opt.OPTIONS.SEARCH_RADIUS) {
                        pluskey = (Object.keys(opt.OPTIONS.SEARCH_RADIUS))[0];
                        textBox = (opt.OPTIONS.SEARCH_RADIUS)[pluskey];
                    }
                } else if ((opt.TYPE == "CD Extra") && (opt.MAX_COUNT != 0) && (opt.MIN_COUNT != 0)) {
                    required.push("CD");
                } else if (opt.TYPE == "COT Extra") {
                    required.push("COT");
                    if (this.parceIds.length > 0) {
                        hasParcels = true;
                        for (let parcelId of this.parceIds) {
                            if (parcelId != "") {
                                cotPara.push([proP.PRODUCT_CODE, parcelId, opt.MAX_COUNT]);
                            }
                        }
                    }
                } else if (opt.TYPE == "OPTA Extra") {
                    required.push("OPTA");
                } else if ((opt.TYPE == "LTS Extra") && (opt.MAX_COUNT != 0) && (opt.MIN_COUNT != 0)) {
                    required.push("LTS");
                } else if (opt.TYPE == "LTS Extra") {
                    required.push("PERMIT Extra");
                } else if (opt.TYPE == "PERMIT Extra" || opt.TYPE == "PROPERTY DETAIL Extra") {
                    required.push("PERMIT");
                } else if (opt.TYPE == "comment") {
                    required.push("COMM");
                } else if (opt.TYPE == "CAN AERIAL Extra") {
                    required.push("YEAR");
                } else if (opt.TYPE == "NEPA Extra") {
                    required.push("NEPA");
                }
            }
            //********end of add option*********
            if (proP.OPTIONAL == "N") {
                this.removeExtra(proP.PRODUCT_TYPE);
                if (proP.EXCLUDE_PRODUCT && proP.EXCLUDE_PRODUCT.length > 0) {
                    this.removeEx(proP.EXCLUDE_PRODUCT);
                }

                let code = "#" + proP.PRODUCT_CODE;
                $(code).prop("checked", true);
                $(code).parents("label").next("span").css('display', 'none');
                let pannel = proP.PRODUCT_CODE + "panel";
                let btn = proP.PRODUCT_CODE + 'btn';
                $("#" + pannel).css("display", "none");
                $('#' + btn).css("display", "none");
                if (document.getElementById(proP.PRODUCT_CODE)) {
                    document.getElementById(proP.PRODUCT_CODE).setAttribute('disabled', 'disabled');
                    //remove from selected product list
                }
                pacProInfo = { "proP": proP, "checked": "true", "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, 'COMM': COMM, 'YEAR': YEAR, 'NEPA': NEPA, 'required': required, "Other": Other };
                this.packageAll.push(pacProInfo);
            } else {
                //*********reomve extra products and report selection*************
                this.removeExtra(proP.PRODUCT_TYPE);
                pacProInfo = { "proP": proP, "checked": "false", "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, 'required': required, "Other": Other };
                //*********end of reomve extra products and report selection*************
                if (document.getElementById(proP.PRODUCT_CODE)) {
                    document.getElementById(proP.PRODUCT_CODE).setAttribute('disabled', 'disabled');
                }

                this.packageAll.push(pacProInfo);
            }
        }
        if ((hasParcels) && (cotPara.length > 0)) {
            for (let para of cotPara) {
                this.saveAttribute(para[0], 'COT', para[1], para[2]);
            }
        }
    }

    proOnSelection(pro, event, title, multi): void {
        $("#hisWarn").css('display', 'none');
        let hasParcels = false;
        if (this.OBMArray.length == 0) {
            let allReport = this.items["Database Report"];
            for (let item of (allReport && allReport.PRODUCTS) ? allReport.PRODUCTS : []) {
                if ((item.PRODUCT_CODE == "20CAN") || (item.PRODUCT_CODE == "23CAN") || (item.PRODUCT_CODE == "25CAN")) {
                    this.OBMArray = item.INCLUDE_PRODUCT;
                }
            }
        }


        if (this.OBMArray.indexOf(pro.PRODUCT_CODE) != -1) {
            if (this.OBMFlag == "Y") {
                for (let item of this.OBMArray) {
                    let code = "#" + item;

                    $(code).prop("checked", false);
                    $(code).prop("disabled", true);
                    return
                }
            }
        }
        $("#xpreReq").css("display", "none");
        $("#fimpreReq").css("display", "none");
        $("#vaporWarn").css("display", "none");
        let returnroot = false;
        if (event.target.checked) {
            if (pro.EXCLUDE_PRODUCT && pro.EXCLUDE_PRODUCT.length > 0) {
                for (let exPro of pro.EXCLUDE_PRODUCT) {
                    let code = "#" + exPro;
                    $(code).prop("checked", false);
                    $(code).prop("disabled", true);
                }
            }
            let allselectedPro = [];
            if ((this.selectedPac) && (this.packageAll)) {
                for (let pac of this.packageAll) {
                    let product_code = pac.proP.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            }
            if (this.selectedPro) {
                for (let pro of this.selectedPro) {
                    let product_code = pro.Spro.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            };
            if (this.selectedRpt) {
                for (let rpt of this.selectedRpt) {
                    let product_code = rpt.Srpt.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            };
            if ((pro.PRODUCT_CODE == "OVERLAY") || (pro.PRODUCT_CODE == "OVERLAY_CA")) {
                $("#xpreReq").css("display", "none");
                $("#fimpreReq").css("display", "none");

                let xflag = false;
                for (let pro of allselectedPro) {
                    if (this.xReqCode.indexOf(pro) != -1) {
                        xflag = true;
                    }
                }
                if (!xflag) {
                    $("#OVERLAY").prop("checked", false);
                    $("#OVERLAY_CA").prop("checked", false);
                    $("#xpreReq").css("display", "block");
                    return
                }
            } else if (pro.PRODUCT_CODE == "FIM_2") {
                let fimflag = false;
                for (let pro of allselectedPro) {
                    if (this.fimReqCode.indexOf(pro) != -1) {
                        fimflag = true;
                    }
                }
                if (!fimflag) {
                    $("#FIM_2").prop("checked", false);
                    $("#fimpreReq").css("display", "block");
                    return
                }
            }
            if (pro.PRODUCT_CODE == "VEC_US1") {
                let vaporflag = false;
                for (let pro of allselectedPro) {
                    if (this.vaporReqCode.indexOf(pro) != -1) {
                        vaporflag = true;
                    }
                }
                if (!vaporflag) {
                    $("#VEC_US1").prop("checked", false);
                    $("#vaporWarn").css("display", "block");
                    return
                }
            }


            if (multi == "N") {
                let proTitle = "." + title;

                $(proTitle).each(function () {
                    if ($(this).is(':checked')) {
                        let abc = $(this).is(':disabled');
                        if ($(this).is(':disabled')) {
                            event.target.setAttribute("checked", false);
                            returnroot = true;
                            return false;
                        } else {
                            $(this).prop("checked", false);
                            $(this).parent().next('button').hide();
                        }
                    }
                })
                if (returnroot) {
                    $("#" + pro.PRODUCT_CODE).prop("checked", false);
                    return;
                }
                let titleArray = [];
                for (let i = 0; i < this.selectedPro.length; i++) {
                    titleArray.push(this.selectedPro[i].title);
                }
                const index: number = titleArray.indexOf(title);
                if (index !== -1) {
                    this.selectedPro.splice(index, 1);
                    this.proSelectedArray.splice(index, 1)
                }
                $("#" + pro.PRODUCT_CODE).prop("checked", true);
            }


            //add selected product
            let allOpt = pro.REQUIRED_FIELDS;
            let timeLine = "";
            let CD = [];
            let COT = [];
            let OPTA = [];
            let LTS = [];
            let Other = "";
            let comm = "";
            let YEAR = [];
            let NEPA = [];
            let radius = "";
            let textBox = "";
            let required = [];
            if (pro.DATASOURCE == "Y") {
                required.push("source");
            }
            let radiuskey = "";
            let timeLinekey = "";
            let pluskey = "";
            for (let opt of allOpt) {
                if (opt.TYPE == "Delivery") {
                    let keys = Object.keys(opt.OPTIONS);
                    keys = keys.filter(function (item) {
                        return item !== ''
                    })
                    timeLinekey = (keys)[0];
                    timeLine = opt.OPTIONS[timeLinekey];
                    required.push("timeline");
                } else if (opt.TYPE == "Search Distance") {
                    let radiuskey = (Object.keys(opt.OPTIONS.SEARCH_DISTANCE))[0];
                    radius = (opt.OPTIONS)[radiuskey];
                    this.selectedBaseRadius = radius;
                    required.push("radius");
                    if (opt.OPTIONS.SEARCH_RADIUS) {
                        pluskey = (Object.keys(opt.OPTIONS.SEARCH_RADIUS))[0];
                        textBox = (opt.OPTIONS.SEARCH_DISTANCE)[radiuskey];
                    }
                } else if ((opt.TYPE == "CD Extra") && (opt.MAX_COUNT != 0) && (opt.MIN_COUNT != 0)) {
                    required.push("CD");
                } else if (opt.TYPE == "COT Extra") {
                    required.push("COT");
                    if (this.parceIds.length > 0) {
                        hasParcels = true;
                    }
                } else if (opt.TYPE == "OPTA Extra") {
                    required.push("OPTA");
                } else if ((opt.TYPE == "LTS Extra") && (opt.MAX_COUNT != 0) && (opt.MIN_COUNT != 0)) {
                    required.push("LTS");
                } else if ((opt.TYPE == "comment") && (opt.MAX_COUNT != 0) && (opt.MIN_COUNT != 0)) {
                    required.push("COMM");
                } else if (opt.TYPE == "PERMIT Extra" || opt.TYPE == "PROPERTY DETAIL Extra") {
                    required.push("PERMIT");
                } else if (opt.TYPE == "CAN AERIAL Extra") {
                    required.push("YEAR");
                } else if (opt.TYPE == "NEPA Extra") {
                    required.push("NEPA");
                }
            }
            let proInfo = { "Spro": pro, "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "title": title, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": [], "COMM": comm, 'YEAR': YEAR, 'NEPA': NEPA, "multi": multi, 'required': required, "Other": Other };
            this.selectedPro.push(proInfo);
            if ((hasParcels) && (this.parceIds.length > 0) && (pro.REQUIRED_FIELDS[0].TYPE == "COT Extra")) {
                for (let parcelId of this.parceIds) {
                    if (parcelId != "") {
                        this.saveAttribute(pro.PRODUCT_CODE, 'COT', parcelId, pro.REQUIRED_FIELDS[0].MAX_COUNT);
                    }
                }
            }
            this.proSelectedArray.push(pro.PRODUCT_NAME);
            this.highlightArea = 'productArea' + (this.selectedPro.length - 1);
        } else {//remove unselected product
            if (pro.EXCLUDE_PRODUCT && pro.EXCLUDE_PRODUCT.length > 0) {
                for (let exPro of pro.EXCLUDE_PRODUCT) {
                    let code = "#" + exPro;
                    $(code).prop("disabled", false);
                }
            }
            let proArray = [];

            for (let i = 0; i < this.selectedPro.length; i++) {
                proArray.push((this.selectedPro[i].Spro).PRODUCT_NAME);
            }
            const index: number = proArray.indexOf(pro.PRODUCT_NAME);
            if (index !== -1) {
                this.selectedPro.splice(index, 1);
                this.proSelectedArray.splice(index, 1);
            }
            let pannel = pro.PRODUCT_CODE + "panel";
            let btn = pro.PRODUCT_CODE + 'btn';
            $("#" + pannel).css("display", "none");
            $('#' + btn).css("display", "none");
        }
        this.xplorerAddOn()
    }


    xplorerAddOn() {
        let codesToCheck = ["AP_US1","AP_US2","AP_US3","TM_US1", "TM_US2", "USA01", "USA04", "USA09", "MSD_US", "WW_TX"]
        let canCodesToCheck= ['AP_1', 'AP_11',  'AP_10', 'OPTA_MAIN', 'PSR_CA1', 'TM_2', 'TM_3', 'RSC_ON', 'TM_1'];
        if (codesToCheck.some( val => $('#' + val).is(':checked') )){
            let code = "#OVERLAY";
            $(code).prop("disabled", false);
            if (!$(code).is(':checked')) {
                $(code).click();
            }
            $(code).prop("disabled", true);
        } else {
            let code = "#OVERLAY";
            $(code).prop("disabled", false);
        }
        if (canCodesToCheck.some( val => $('#' + val).is(':checked') )){
            let code = "#OVERLAY_CA";
            $(code).prop("disabled", false);
            if (!$(code).is(':checked')) {
                $(code).click();
            }
            $(code).prop("disabled", true);
        } else {
            let code = "#OVERLAY_CA";
            $(code).prop("disabled", false);
        }
    }

    rptOnSelection(rpt, event, title, multi): void {
        this.hideBuffer();
        if (this.OBMArray.length == 0) {
            let allReport = this.items["Database Report"];
            for (let item of (allReport && allReport.PRODUCTS) ? allReport.PRODUCTS : []) {
                if ((item.PRODUCT_CODE == "20CAN") || (item.PRODUCT_CODE == "23CAN") || (item.PRODUCT_CODE == "25CAN")) {
                    this.OBMArray = item.INCLUDE_PRODUCT;
                }
            }
        }

        $('.' + 'highlightArea').each(function () { });
        $(".reportList").css('display', 'none');
        this.SelectedDataSource = [];
        this.SelectedDataSourceCode = [];
        let returnroot = false;
        if (event.target.checked) {//add selected product

            if (multi == "N") {

                let i = 0;
                let rptTitle = "." + title;
                $(rptTitle).each(function () {
                    if ($(this).is(':checked')) {
                        if ($(this).is(':disabled')) {
                            event.target.setAttribute("checked", false);
                            returnroot = true;
                            return false;
                        } else {
                            if (($(this).attr('id') == "20CAN") || ($(this).attr('id') == "20CAN") || ($(this).attr('id') == "20CAN")) {
                                $(this).click();
                            } else {
                                $(this).prop("checked", false);
                                $(this).parent().next('button').hide();
                            }
                        }
                    }
                })
                if (returnroot) {
                    $("#" + rpt.PRODUCT_CODE).prop("checked", false);
                    return;
                }
                let titleArray = [];
                for (let i = 0; i < this.selectedRpt.length; i++) {
                    titleArray.push(this.selectedRpt[i].title);
                }
                const index: number = titleArray.indexOf(title);
                if (index !== -1) {
                    this.selectedRpt.splice(index, 1);
                    this.rptSelectedArray.splice(index, 1)
                }
                $("#" + rpt.PRODUCT_CODE).prop("checked", true);
                let pannel = rpt.PRODUCT_CODE + "panel";
                let btn = rpt.PRODUCT_CODE + 'btn';
                $("#" + pannel).css("display", "block");
                $('#' + btn).css("display", "inline");
                $('#' + btn).html('-');
            }
            let allOpt = rpt.REQUIRED_FIELDS;
            let timeLine = "";
            let radius = "";
            let CD = [];
            let COT = [];
            let OPTA = [];
            let LTS = [];
            let comm = "";
            let textBox = "";
            let required = [];
            let radiuskey = "";
            let timeLinekey = "";
            let pluskey = "";
            let Buffer = '';
            if (rpt.DATASOURCE == "Y") {
                required.push("source");
            }
            if ((rpt.MAPBUFFERSIZE != "") && (rpt.MAPBUFFERUNIT != "")) {
                this.showBuffer(rpt.MAPBUFFERUNIT, rpt.MAPBUFFERSIZE);
            }
            for (let opt of allOpt) {
                if (opt.TYPE == "Delivery") {
                    let keys = Object.keys(opt.OPTIONS);
                    keys = keys.filter(function (item) {
                        return item !== ''
                    })
                    timeLinekey = (keys)[0];
                    timeLine = opt.OPTIONS[timeLinekey];
                    required.push("timeline");
                } else if (opt.TYPE == "Search Distance") {
                    radiuskey = (Object.keys(opt.OPTIONS.SEARCH_DISTANCE))[0];
                    radius = (opt.OPTIONS.SEARCH_DISTANCE)[radiuskey];
                    if ((rpt.DATASOURCE == "Y") && (radius == "")) {
                        required.push("source");
                    } else {
                        required = required.filter(function (item) {
                            return item !== 'source'
                        })
                        this.SelectedDataSource = [];
                    }

                    this.selectedBaseRadius = radius;
                    required.push("radius");
                    if (opt.OPTIONS.SEARCH_RADIUS) {
                        pluskey = (Object.keys(opt.OPTIONS.SEARCH_RADIUS))[0];
                        textBox = (opt.OPTIONS.SEARCH_RADIUS)[pluskey];
                    }
                } else if (opt.TYPE == "CD Extra") {
                    required.push("CD");
                } else if (opt.TYPE == "COT Extra") {
                    required.push("COT");
                }
                else if (opt.TYPE == 'buffersize') {
                    required.push("Buffer");
                    if (opt.DEFAULT) {
                        Buffer = opt.DEFAULT;
                    }
                }
            }

            let rptInfo = { "Srpt": rpt, "timeLine": timeLine, "timeLinekey": timeLinekey, "radius": radius, "radiuskey": radiuskey, "plus": textBox, "pluskey": pluskey, "title": title, "CD": CD, "COT": COT, "OPTA": OPTA, "LTS": LTS, "COMM": comm, "multi": multi, "Buffer": Buffer, 'required': required };
            this.selectedRpt = [];
            this.rptSelectedArray = [];
            this.selectedRpt.push(rptInfo);
            this.rptSelectedArray.push(rpt.PRODUCT_NAME)
            this.highlightArea = 'reportArea' + (this.selectedRpt.length - 1);
            //OBM part:
            this.xplorerAddOn()
            if ((rpt.PRODUCT_CODE == "20CAN") || (rpt.PRODUCT_CODE == "23CAN") || (rpt.PRODUCT_CODE == "25CAN")) {
                for (let item of this.OBMArray) {
                    let code = "#" + item;
                    $(code).prop("disabled", false);
                    if (!$(code).is(':checked')) {
                        this.OBMFlag = "N";
                        $(code).click();
                    }
                    $(code).prop("disabled", true);
                }
            } else {
                for (let item of this.OBMArray) {
                    let code = "#" + item;
                    $(code).prop("disabled", false);
                    if ($(code).is(':checked')) {
                        this.OBMFlag = "N";
                        $(code).click();
                    }
                    $(code).prop("disabled", true);
                }
                this.OBMFlag = "N";
            }
        } else {//remove unselected product

            let rptArray = [];
            this.hideBuffer();

            for (let i = 0; i < this.selectedRpt.length; i++) {
                rptArray.push((this.selectedRpt[i].Srpt).PRODUCT_NAME);
            }

            const index: number = rptArray.indexOf(rpt.PRODUCT_NAME);
            if (index !== -1) {
                this.selectedRpt.splice(index, 1);
                this.rptSelectedArray.splice(index, 1);
            }

            let pannel = rpt.PRODUCT_CODE + "panel";
            let btn = rpt.PRODUCT_CODE + 'btn';
            $("#" + pannel).css("display", "none");
            $('#' + btn).css("display", "none");
            this.xplorerAddOn()
            //OBM part:
            if ((rpt.PRODUCT_CODE == "20CAN") || (rpt.PRODUCT_CODE == "23CAN") || (rpt.PRODUCT_CODE == "25CAN")) {
                for (let item of this.OBMArray) {
                    let code = "#" + item;
                    $(code).prop("disabled", false);
                    if ($(code).is(':checked')) {
                        this.OBMFlag = "N";
                        $(code).click();
                    }
                    $(code).prop("disabled", true);
                }
            }
        }
        if (this.country == 'CAN') {
            if (this.selectedRpt.length > 0) {
                let code = "#OVERLAY_CA";
                if (!$(code).is(':checked')) {
                    $(code).prop("disabled", false);
                    $(code).click();
                }
                $(code).prop("disabled", true);
            } else {
                let code = "#OVERLAY_CA";
                if ($(code).is(':checked')) {
                    $(code).prop("disabled", false);
                    $(code).click();
                }
            }
        }
    }

    deliveryOnSelection(group, prorpt, key, value, event): void {
        let proArray = [];
        if (group == "package") {
            for (let i = 0; i < this.packageAll.length; i++) {
                proArray.push((this.packageAll[i].proP).PRODUCT_NAME);
            }
            const indexPro: number = proArray.indexOf(prorpt.PRODUCT_NAME);
            if (indexPro !== -1) {
                this.packageAll[indexPro].timeLine = value;
                this.packageAll[indexPro].timeLinekey = key;
            }
        } else if (group == "product") {
            for (let i = 0; i < this.selectedPro.length; i++) {
                proArray.push((this.selectedPro[i].Spro).PRODUCT_NAME);
            }
            const indexPro: number = proArray.indexOf(prorpt.PRODUCT_NAME);
            if (indexPro !== -1) {
                this.selectedPro[indexPro].timeLine = value;
                this.selectedPro[indexPro].timeLinekey = key;
            }
        } else if (group == "report") {
            for (let i = 0; i < this.selectedRpt.length; i++) {
                proArray.push((this.selectedRpt[i].Srpt).PRODUCT_NAME);
            }
            const indexPro: number = proArray.indexOf(prorpt.PRODUCT_NAME);
            if (indexPro !== -1) {
                this.selectedRpt[indexPro].timeLine = value;
                this.selectedRpt[indexPro].timeLinekey = key;
            }
        }
    }

    clearSelection(): void {
        this.hideBuffer();
        $('.package-div').each(function () {
            $(this).toggle(true);
        });
        $('#custom-title').toggle(true);
        $('#standard-title').toggle(true);
        $('#pacBtn').toggle(true);
        $("#clear-selection").toggle(false);

        let pac: any;
        pac = this.selectedPac;
        if (pac.PRODUCTS) {
            for (let proP of pac.PRODUCTS) {
                if (this.typeArray) {
                    for (let code of this.codeArray) {
                        let myclass = "." + $("#" + code).attr("class");
                        $(myclass).each(function () {
                            $(this).removeAttr("disabled");
                        });
                    }
                }
                if (proP.EXCLUDE_PRODUCT && proP.EXCLUDE_PRODUCT.length > 0) {
                    for (let exPro of proP.EXCLUDE_PRODUCT) {
                        let myclass = "." + $("#" + exPro).attr("class");
                        let myitem = "#" + exPro + myclass;
                        $(myitem).removeAttr("disabled");
                    }
                }
                $("#" + proP.PRODUCT_CODE).prop("checked", false);
                $("#" + proP.PRODUCT_CODE).parents("label").next("span").css('display', 'inline');
                if (document.getElementById(proP.PRODUCT_CODE)) { document.getElementById(proP.PRODUCT_CODE).removeAttribute('disabled'); }
            }
            this.cookieService.deleteCookie('Package');
            this.cookieService.deleteCookie('PackageAll');
        }
        $(".selPackage").prop('checked', false);
        this.selectedPac = [];
        this.packageAll = [];
        $("#editBtn").css("display", "none");
    }

    plusOnSelection(group, rpt, key): void {
        let value = 0;
        let allOpt = rpt.REQUIRED_FIELDS;
        for (let opt of allOpt) {
            if (opt.TYPE == "Search Distance") {
                value = (opt.OPTIONS.SEARCH_RADIUS)[key];
            }
        }
        this.selectedRadiusPlus = value;

        let rptArray = [];
        for (let i = 0; i < this.selectedRpt.length; i++) {
            rptArray.push((this.selectedRpt[i]).Srpt.PRODUCT_CODE);
        }
        let pacArray = [];
        for (let i = 0; i < this.packageAll.length; i++) {
            pacArray.push((this.packageAll[i].proP).PRODUCT_CODE);
        }
        const indexRpt: number = rptArray.indexOf(rpt.PRODUCT_CODE);
        const indexPac: number = pacArray.indexOf(rpt.PRODUCT_CODE);
        if (indexRpt !== -1) {
            this.selectedRpt[indexRpt].plus = value;
            this.selectedRpt[indexRpt].pluskey = key;
        } else if (indexPac !== -1) {
            this.packageAll[indexPac].plus = value;
            this.packageAll[indexPac].pluskey = key;
        }
    }

    PacOptOnSelection(total, pacCode, pacType, event): void {
        $("#hisWarn").css('display', 'none');
        let i = 0;
        $("." + "pacOpt").each(function () {
            if ($(this).is(':checked')) {
                i++
            }
        })
        let pacArray = [];
        for (let i = 0; i < this.packageAll.length; i++) {
            pacArray.push((this.packageAll[i].proP).PRODUCT_CODE);
        }

        const indexPac: number = pacArray.indexOf(pacCode);
        if (event.target.checked) {
            if (i <= total) {
                if (indexPac !== -1) {
                    this.removeExtra(pacType);
                    this.packageAll[indexPac].checked = "true";
                }


                if (document.getElementById(pacCode)) {
                    document.getElementById(pacCode).removeAttribute('disabled');
                }

                $("#" + pacCode).prop("checked", true);
                $("#" + pacCode).parents("label").next("span").css('display', 'none');
                if (document.getElementById(pacCode)) {
                    document.getElementById(pacCode).setAttribute('disabled', 'disabled');
                }
            } else {
                event.target.checked = false;
            }
        } else {
            if (document.getElementById(pacCode)) {
                document.getElementById(pacCode).removeAttribute('disabled');
            }

            $("#" + pacCode).prop("checked", false);
            $("#" + pacCode).parents("label").next("span").css('display', 'inline');
            if (document.getElementById(pacCode)) {
                document.getElementById(pacCode).setAttribute('disabled', 'disabled');
            }
            if (indexPac !== -1) {
                this.packageAll[indexPac].checked = "false";
            }
        }
    }

    searchSelection(group, rpt, key): void {
        let value = "";
        let preDatasource = [];
        let allOpt = rpt.REQUIRED_FIELDS;
        for (let opt of allOpt) {
            if (opt.TYPE == "Search Distance") {
                value = (opt.OPTIONS.SEARCH_DISTANCE)[key];
            }
        }


        let rptArray = [];

        for (let i = 0; i < this.selectedRpt.length; i++) {
            rptArray.push((this.selectedRpt[i]).Srpt.PRODUCT_CODE);
        }
        let pacArray = [];
        for (let i = 0; i < this.packageAll.length; i++) {
            pacArray.push((this.packageAll[i].proP).PRODUCT_CODE);
        }
        const indexRpt: number = rptArray.indexOf(rpt.PRODUCT_CODE);
        const indexPac: number = pacArray.indexOf(rpt.PRODUCT_CODE)
        if (indexRpt !== -1) {
            this.selectedRpt[indexRpt].radius = value;
            this.selectedRpt[indexRpt].radiuskey = key;
            let requireField = this.selectedRpt[indexRpt].required;
            if ((value != "") && (requireField.indexOf('source') != -1)) {
                requireField = requireField.filter(function (item) {
                    return item !== 'source'
                })
                this.selectedRpt[indexRpt].required = requireField;
                this.SelectedDataSource = [];
            } else if ((value == "") && (requireField.indexOf('source') == -1) && (rpt.DATASOURCE == "Y")) {
                requireField.push("source");
            }
            this.resetRadiusPlus(rpt, key)
        } else if (indexPac !== -1) {
            this.packageAll[indexPac].radius = value;
            this.packageAll[indexPac].radiuskey = key;
            this.resetRadiusPlus(rpt, key)
        }
    }
    resetRadiusPlus(rpt, key): void {
        if(rpt.PRODUCT_CODE=='USA01'&&key!='ASTM Standard'){
            this.plusOnSelection([], rpt, 'None')
        }
    }
    removeEx(codeArray) {
        for (let code of codeArray) {

            let myclass = "." + $("#" + code).attr("class");
            let myitem = "#" + code + myclass;
            $(myitem).attr("disabled", true);
            $(myitem).prop("checked", false);
        }
    }

    removeExtra(key): void {
        let code: string;
        let proTypeArray = [];
        let rptTypeArray = [];
        for (let i = 0; i < this.selectedPro.length; i++) {
            proTypeArray.push(this.selectedPro[i].Spro.PRODUCT_TYPE);
        }
        for (let i = 0; i < this.selectedRpt.length; i++) {
            rptTypeArray.push(this.selectedRpt[i].Srpt.PRODUCT_TYPE);
        }
        if (proTypeArray.indexOf(key) != -1) {
            let j = proTypeArray.indexOf(key)
            code = this.selectedPro[j].Spro.PRODUCT_CODE;
        } else if (rptTypeArray.indexOf(key) != -1) {
            let j = rptTypeArray.indexOf(key)
            code = this.selectedRpt[j].Srpt.PRODUCT_CODE;
        }

        let className = "." + $("#" + code).attr("class");
        let idGroup = $(className);
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            for (let id of idGroup) {

                const index: number = groupArray.indexOf(id.id);
                if (index !== -1) {
                    let panelid: string
                    if (this.selectedPro[index].multi && this.selectedPro[index].multi == "N") {
                        $("#" + id.id).prop("checked", false);
                        panelid = id.id;
                    } else {
                        $("#" + code).prop("checked", false);
                        panelid = code;
                    }
                    let pannel = panelid + "panel";
                    let btn = panelid + 'btn';
                    $("#" + pannel).css("display", "none");
                    $('#' + btn).css("display", "none");
                    this.selectedPro.splice(index, 1);
                    this.proSelectedArray.splice(index, 1);
                }
            }
        }

        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            for (let id of idGroup) {
                const index: number = groupArray.indexOf(id.id);
                let panelid: string;
                if (index !== -1) {
                    if (this.selectedRpt[index].multi && this.selectedRpt[index].multi == "N") {
                        $("#" + id.id).prop("checked", false);
                        panelid = id.id;
                    } else {
                        $("#" + code).prop("checked", false);
                        panelid = code;
                    }
                    let pannel = panelid + "panel";
                    let btn = panelid + 'btn';
                    $("#" + pannel).css("display", "none");
                    $('#' + btn).css("display", "none");
                    this.selectedRpt.splice(index, 1);
                    this.rptSelectedArray.splice(index, 1);
                }
            }
        }

        if (this.typeArray.length == 0) {
            let keyArray = Object.keys(this.items);
            for (let key of keyArray) {
                if (this.items[key].IS_MULTI_SELECT == "N") {
                    if (this.items[key].PRODUCTS.length > 0) {
                        let item = this.items[key].PRODUCTS;
                        this.codeArray.push(item[0].PRODUCT_CODE);
                        this.typeArray.push(item[0].PRODUCT_TYPE);
                    }
                }
            }
        }

        if (this.typeArray.indexOf(key) != -1) {
            let k = this.typeArray.indexOf(key);
            let code = this.codeArray[k];
            let myclass = "." + $("#" + code).attr("class");
            $(myclass).each(function () {
                $(this).attr("disabled", true);
            });
        }
    }

    addStreet(code, max, source): void {
        $(".invalidWarn").css("display", "none");
        $("#searchWarn").css("display", "none");
        let streetId = "";
        let rangeId = "";
        let noteId = "";
        let singleText = "";
        if (source == "pageInput") {
            streetId = "#" + code + "street";
            rangeId = "#" + code + "range";
            noteId = "#" + code + "note";
            if ($(streetId).prop("value") == "") {
                $("#searchWarn").css("display", "block");
                return
            }
            if ((($(streetId).prop("value")).indexOf(",") != -1) || (($(streetId).prop("value")).indexOf(";") != -1)) {
                $(".invalidWarn").css("display", "block");
                return;
            }
            singleText = $(streetId).prop("value") + " , " + $(rangeId).prop("value") + " , " + $(noteId).prop("value");
        } else if (source == "modalInput") {
            streetId = "#modalStreetName";
            rangeId = "#modalStreetNo";
            noteId = "#modalStreetNote"
            singleText = $(streetId).prop("value") + " , " + $(rangeId).prop("value") + " , " + $(noteId).prop("value");
        }

        //ADD texts to according CD
        this.saveAttribute(code, "CD", singleText, max);
        //end of ADD texts to according CD

        if (this.country == "USA") $(streetId).prop("value", "");
        $(rangeId).prop("value", "");
        $(noteId).prop("value", "");
    }

    deleteSearch(code, key): void {
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {

                (this.packageAll[index].CD).splice(key, 1)
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedPro[index].CD.splice(key, 1)
            }
        }
        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedRpt[index].CD.splice(index, 1)
            }
        }
    }

    saveAttribute(code, attribute, value, max): void {
        let CDid = '#' + code + "street";
        ($(CDid).siblings('p')).css({ "display": "none" });
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                if (attribute == "CD") {
                    if (((this.packageAll[index].CD).length) < max) {
                        this.packageAll[index].CD.push(value);
                    } else {
                        ($(CDid).siblings('p')).css({ "color": "red", "font-size": "11px", "display": "block" });
                    }
                }
                if (attribute == "COT") {
                    if (((this.packageAll[index].COT).length) < max) {
                        this.packageAll[index].COT.push(value);
                        $("#cotWarnMax").css({ "display": "none" });
                    } else {
                      $("#cotWarnMax").css({ "display": "block" });
                    }
                }
                if (attribute == "OPTA") {
                    if (((this.packageAll[index].OPTA).length) < max) {
                        this.packageAll[index].OPTA.push(value);
                    }
                }
                if (attribute == "LTS") {
                    if (((this.packageAll[index].LTS).length) < max) {
                        this.packageAll[index].LTS.push(value);
                    }
                }
                if (attribute == "COMM") {
                    this.packageAll[index].COMM = value;
                }
                if (attribute == "YEAR") {
                    if (value.length <= max) {
                        this.packageAll[index].YEAR = value;
                    }
                }
                if (attribute == "NEPA") {
                    this.packageAll[index].NEPA = value;
                }
                if (attribute == "PERMIT") { this.packageAll[index].Other = value; }
                if (attribute == "timeLine") { this.packageAll[index].timeLine = value; }
                if (attribute == "radius") { this.packageAll[index].radius = value; }
                if (attribute == "plus") { this.packageAll[index].plus = value; }
            }
        }

        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                if (attribute == "CD") {
                    if (((this.selectedPro[index].CD).length) < max) {
                        this.selectedPro[index].CD.push(value);
                    } else {
                        ($(CDid).siblings('p')).css({ "color": "red", "font-size": "11px", "display": "block" });
                    }
                }
                if (attribute == "COT") {
                    if (((this.selectedPro[index].COT).length) < max) {
                        this.selectedPro[index].COT.push(value);
                        $("#cotWarnMax").css({ "display": "none" });
                    } else {
                      $("#cotWarnMax").css({ "display": "block" });
                    }
                }
                if (attribute == "OPTA") {
                    if (((this.selectedPro[index].OPTA).length) < max) {
                        this.selectedPro[index].OPTA.push(value);
                    }
                }
                if (attribute == "LTS") {
                    if (((this.selectedPro[index].LTS).length) < max) {
                        this.selectedPro[index].LTS.push(value);
                    }
                }
                if (attribute == "YEAR") {
                    if (value.length <= max) {
                        this.selectedPro[index].YEAR = value;
                    }
                }
                if (attribute == "NEPA") {
                    this.selectedPro[index].NEPA = value;
                }
                if (attribute == "PERMIT") { this.selectedPro[index].Other = value; }
                if (attribute == "timeLine") { this.selectedPro[index].timeLine = value; }
                if (attribute == "radius") { this.selectedPro[index].radius = value; }
                if (attribute == "plus") { this.selectedPro[index].plus = value; }
                if (attribute == "COMM") {
                    this.selectedPro[index].COMM = value;
                }
            }
        }
        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                if (attribute == "CD") {
                    if (((this.selectedRpt[index].CD).length) < max) { this.selectedRpt[index].CD.push(value); }
                }
                if (attribute == "COT") {
                    if (((this.selectedRpt[index].COT).length) < max) {
                        this.selectedRpt[index].COT.push(value);
                        $("#cotWarnMax").css({ "display": "none" });
                    } else {
                      $("#cotWarnMax").css({ "display": "block" });
                    }
                }
                if (attribute == "OPTA") {
                    if (((this.selectedRpt[index].OPTA).length) < max) {
                        this.selectedRpt[index].OPTA.push(value);
                    }
                }
                if (attribute == "LTS") {
                    if (((this.selectedRpt[index].LTS).length) < max) {
                        this.selectedRpt[index].LTS.push(value);
                    }
                }
                if (attribute == "COMM") {
                    this.selectedRpt[index].COMM = value;
                }
                if (attribute == "timeLine") { this.selectedRpt[index].timeLine = value; }
                if (attribute == "radius") { this.selectedRpt[index].radius = value; }
                if (attribute == "plus") { this.selectedRpt[index].plus = value; }
            }
        }
    }

    removeCDitem(proCode, itemIndex) {
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.packageAll[index].CD.splice(itemIndex, 1);
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.selectedPro[index].CD.splice(itemIndex, 1);
            }
        }
    }

    removeCOTitem(proCode, itemIndex) {
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.packageAll[index].COT.splice(itemIndex, 1);
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.selectedPro[index].COT.splice(itemIndex, 1);
            }
        }
    }

    removeOPTAitem(proCode, itemIndex): void {
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.packageAll[index].OPTA.splice(itemIndex, 1);
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.selectedPro[index].OPTA.splice(itemIndex, 1);
            }
        }
    }

    removeLTSitem(proCode, itemIndex): void {
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.packageAll[index].LTS.splice(itemIndex, 1);
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(proCode);
            if (index !== -1) {
                this.selectedPro[index].LTS.splice(itemIndex, 1);
            }
        }
    }

    removeYear(code): void {
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedPro[index].YEAR = [];
            }
        }
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.packageAll[index].YEAR = [];
            }
        }
        $('.yearbtn').each(function () {
            $(this).removeClass('yearbtn');
            $(this).addClass('unyearbtn');
            if ($(this).siblings('p').css('display') != 'none') {
                $(this).siblings('p').css('display', 'none');
            }
        })
    }

    saveCOT(code, max, event): void {
        let cotText = $(event.target).siblings("input").val();
        if (cotText == "") {
            return
        }




        $(event.target).siblings("input").val("");
        this.saveAttribute(code, "COT", cotText, max);
    }

    saveOPTA(code, max, event): void {
        let OPTAText = $(event.target).siblings("input").val();
        if (OPTAText == "") {
            return
        }
        $(event.target).siblings("input").val("");
        this.saveAttribute(code, "OPTA", OPTAText, max);
    }

    saveLTS(code, max, event): void {
        let LTSText = $(event.target).siblings("input").val();
        if (LTSText == "") {
            return
        }
        $(event.target).siblings("input").val("");
        this.saveAttribute(code, "LTS", LTSText, max);
    }

    addNEPA(code, max, event): void {
        let NEPAText = $(event.target).siblings("textarea").val();
        if (NEPAText == "") {
            return
        }
        $(event.target).siblings("input").val("");
        this.saveAttribute(code, "NEPA", NEPAText, max);
    }

    removeNEPA(code) {
        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedRpt[index].NEPA = "";
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedPro[index].NEPA = "";
            }
        }
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.packageAll[index].NEPA = "";;
            }
        }
    }

    savePERMIT(code, event): void {
        $(".permitinvalidWarn").css("display", "none");
        $("#permitWarn").css("display", "none");
        let PermitText = $(event.target).siblings("input").val();
        let cityText = $(event.target).siblings("input").next().val();
        if (PermitText == "") {
            $("#permitWarn").css("display", "block");
            return
        }
        if (cityText == "") {
            $("#permitWarn").css("display", "block");
            return
        }
        if ((PermitText.indexOf(",") != -1) || (PermitText.indexOf(";") != -1)) {
            $(".permitinvalidWarn").css("display", "block");
            return;
        }
        if ((cityText.indexOf(",") != -1) || (cityText.indexOf(";") != -1)) {
            $(".permitinvalidWarn").css("display", "block");
            return;
        }
        let singleText = PermitText + "," + cityText + "," + this.unchange;
        this.saveAttribute(code, "PERMIT", singleText, 1);
    }

    hidePackage(idString): void {
        if ($("#" + idString).css("display") == "block") {
            this.btnText = '<i class="fa fa fa-plus-square-o"></i>';
            $("#" + idString).css("display", "none");
        } else {
            this.btnText = '<i class="fa fa-minus-square-o"></i>';
            $("#" + idString).css("display", "block");
        }
    }

    addBuffer(code, unit, event): void {
        let buffer = $(event.target).siblings('input').val();
        if (buffer != "") {
            if (this.packageAll) {
                let groupArray = [];
                for (let i = 0; i < this.packageAll.length; i++) {
                    groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
                }
                const index: number = groupArray.indexOf(code);
                if (index !== -1) {
                    this.packageAll[index].Buffer = buffer;
                }
            }
            if (this.selectedRpt) {
                let groupArray = [];
                for (let i = 0; i < this.selectedRpt.length; i++) {
                    groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
                }
                const index: number = groupArray.indexOf(code);
                if (index !== -1) {
                    this.selectedRpt[index].Buffer = buffer;
                }
            }
            //---add buffer
            let sKey = this.cookieService.getCookie("sessionKey");
            let customerId = this.cookieService.getCookie('customerID');
            let geoType = this.cookieService.getCookie('geoType');

            let type: string;
            if (geoType == "POINT") {
                type = "centre";
            } else if (geoType == "polyline") {
                geoType = "POLYLINE";
                type = "edge";
            } else if (geoType == "polygon") {
                geoType = "POLYGON";
                type = "edge";
            }
            if (unit == "meters") {
                unit = "metres";
            } else if (unit == "miles") {
                unit = "mile";
            }
            let geometry = this.cookieService.getCookie('selectedGeometry');
            this.getGeoBuffer(customerId, geometry, buffer, unit, type, geoType, sKey);
        }
    }

    showBuffer(unit, buffer): void {
        if (buffer != "") {
            let sKey = this.cookieService.getCookie("sessionKey");
            let customerId = this.cookieService.getCookie('customerID');
            let geoType = this.cookieService.getCookie('geoType');

            let type: string;
            if (geoType == "POINT") {
                type = "centre";
            } else if (geoType == "polyline") {
                geoType = "POLYLINE";
                type = "edge";
            } else if (geoType == "polygon") {
                geoType = "POLYGON";
                type = "edge";
            }
            if (unit == "meters") {
                unit = "metres";
            } else if (unit == "miles") {
                unit = "mile";
            }
            let geometry = this.cookieService.getCookie('selectedGeometry');
            this.getGeoBuffer(customerId, geometry, buffer, unit, type, geoType, sKey);
        }
    }

    clearBuffer(code, event): void {
        $(event.target).siblings('input').val("0");
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.packageAll[index].Buffer = "0";
            }
        }
        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedRpt[index].Buffer = "0";
            }
        }
        if (this.geoBuffer && this.geoBuffer.setMap) this.geoBuffer.setMap(null);
    }

    hideBuffer(): void {
        if (this.geoBuffer && this.geoBuffer.setMap) this.geoBuffer.setMap(null);
    }

    addComment(code, event): void {
        let comText = $(event.target).siblings("textarea").val();
        if (comText == "") {
            return
        }
        this.saveAttribute(code, "COMM", comText, 1);
    }

    removeComment(code): void {
        if (this.selectedRpt) {
            let groupArray = [];
            for (let i = 0; i < this.selectedRpt.length; i++) {
                groupArray.push(this.selectedRpt[i].Srpt.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedRpt[index].COMM = "";
            }
        }
        if (this.selectedPro) {
            let groupArray = [];
            for (let i = 0; i < this.selectedPro.length; i++) {
                groupArray.push(this.selectedPro[i].Spro.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.selectedPro[index].COMM = "";
            }
        }
        if (this.packageAll) {
            let groupArray = [];
            for (let i = 0; i < this.packageAll.length; i++) {
                groupArray.push(this.packageAll[i].proP.PRODUCT_CODE);
            }
            const index: number = groupArray.indexOf(code);
            if (index !== -1) {
                this.packageAll[index].COMM = "";;
            }
        }
    }

    saveAerial(code, event, max): void {
        $(event.target).siblings('p').css('display', 'none');

        let year = $(event.target).text();
        if ($(event.target).hasClass('unyearbtn')) {
            $(event.target).removeClass('unyearbtn');
            $(event.target).addClass('yearbtn');
        } else {
            $(event.target).removeClass('yearbtn');
            $(event.target).addClass('unyearbtn');
        }
        let selectedYear = [];
        $('.yearbtn').each(function () {
            selectedYear.push($(this).text());
        })
        if (selectedYear.length > max) {
            ;
            $(event.target).siblings('p').css('display', 'block');
            $(event.target).removeClass('yearbtn');
            $(event.target).addClass('unyearbtn');
            selectedYear = selectedYear.slice(0, -1);
            return
        }
        this.saveAttribute(code, "YEAR", selectedYear, max);
    }

    public modifyGeo() {
        this.ngZone.run(() => {
            this.router.navigate(['/home']);
        });
    }

    public saveToOrder(): void {
        $("#hisWarn").css('display', 'none');
        let flag = true;
        let dataSourceRequired = false;
        let cotRequired = false;
        let cdId = "";
        let ltsId = "";
        let cotId = "";
        let yearId = '';
        let nepaId = '';
        let bufferId = '';
        let permitId = '';
        let cdminCount: number;
        let ltsCount: number;
        let cotCount: number;
        let yearCount: number;
        if ($(".cdSummary")) {
            let idstring = $(".cdSummary").attr("id");
            if (idstring) {
                cdId = idstring.replace("xxcdxx", "");
            }
        }
        if ($(".ltsSummary")) {
            let idstring = $(".ltsSummary").attr("id");
            if (idstring) {
                ltsId = idstring.replace("lts", "");
            }
        }
        if ($(".cotSummary")) {
            let idstring = $(".cotSummary").attr("id");
            if (idstring) {
              cotId = idstring.replace("cot", "");
            }
        }
        if ($(".yearSummary")) {
            let idstring = $(".yearSummary").attr("id");
            if (idstring) {
                yearId = idstring.replace("year", "");
            }
        }
        if ($(".nepaSummary")) {
            let idstring = $(".nepaSummary").attr("id");
            if (idstring) {
                nepaId = idstring.replace("nepa", "");
            }
        }
        if ($(".bSummary")) {
            let idstring = $(".bufferSummary").attr("id");
            if (idstring) {
                bufferId = idstring.replace("buffer", "");
            }
        }
        if ($(".permitSummary")) {
            let idstring = $(".permitSummary").attr("id");
            if (idstring) {
                permitId = idstring.replace("address", "");
            }
        }
        $("#noSelectedPro").css({ "display": "none" });
        $("#selectedOptWarn").css("display", "none");
        let orderId = "";
        if (this.cookieService.getCookie("OrderID")) {
            orderId = this.cookieService.getCookie("OrderID");
        }

        let orderInfo: any
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'));
        } else if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        }
        if (orderInfo) {
            if ($("#editedAddress").val()) {
                orderInfo.address1 = $("#editedAddress").val();
                let input = $("#editedAddress").val();
                let modifiedinput = input.replace(/,/g, '\U002C');
                this.cookieService.setCookieSession("userInput", modifiedinput);
            }
            if ($("#editedC1").val()) {
                orderInfo.city = $("#editedC1").val();
            }
            orderInfo.products = [];
            if ((this.selectedPac) && (this.packageAll)) {
                let packageInfo = this.selectedPac;
                let packagePro = this.packageAll;
                let Package_oid = packageInfo.PACKAGE_OID;

                let totalOption = packageInfo.OPTION_TOTAL;
                let optSelected = 0;
                $("." + "pacOpt").each(function () {
                    if ($(this).is(':checked')) {
                        optSelected++;
                    }
                })
                if (totalOption > optSelected) {
                    $("#selectedOptWarn").css("display", "block");
                    flag = false;
                }
                for (let pac of packagePro) {
                    if (pac.required.indexOf('source') != -1) {
                        dataSourceRequired = true;
                    }
                    if (pac.checked == "true") {
                        let product = {
                            "order_id": "",
                            "order_num": "",
                            "product_code": "",
                            "type": "",
                            "quote_requested": "",
                            "turnaround": "",  //------NUMBER
                            "input": null,
                            "comment": "",
                            "city_directory_street": [],
                            "package_oid": "",
                        }
                        if (pac.proP.PRODUCT_CODE == cdId) {
                            for (let item of pac.proP.REQUIRED_FIELDS) {
                                if (item.TYPE == "CD Extra") {
                                    cdminCount = item.MIN_COUNT;
                                }
                            }
                            if (cdminCount > pac.CD.length) {
                                flag = false;
                                $(".cdSummary").css({ "color": "red" });
                                $("#miniWarn").css({ "display": "block" });
                            } else {
                                $(".cdSummary").css({ "color": "black" });
                                $("#miniWarn").css({ "display": "none" });
                            }
                        }
                        if (pac.proP.PRODUCT_CODE == ltsId) {
                            for (let item of pac.proP.REQUIRED_FIELDS) {
                                if (item.TYPE == "LTS Extra") {
                                    ltsCount = item.MIN_COUNT;
                                }
                            }
                            if (ltsCount > pac.LTS.length) {
                                flag = false;
                                $(".ltsSummary").css({ "color": "red" });
                                $("#ltsWarn").css({ "display": "block" });
                            } else {
                                $(".ltsSummary").css({ "color": "black" });
                                $("#ltsWarn").css({ "display": "none" });
                            }
                        }
                        if (pac.proP.PRODUCT_CODE == cotId) {
                          for (let item of pac.proP.REQUIRED_FIELDS) {
                              if (item.TYPE == "COT Extra") {
                                  cotCount = item.MIN_COUNT;
                              }
                          }
                          if (cotCount > pac.COT.length) {
                              flag = false;
                              $(".cotSummary").css({ "color": "red" });
                              $("#cotWarn").css({ "display": "block" });
                          } else {
                              $(".cotSummary").css({ "color": "black" });
                              $("#cotWarn").css({ "display": "none" });
                          }
                      }
                        if (pac.proP.PRODUCT_CODE == yearId) {
                            for (let item of pac.proP.REQUIRED_FIELDS) {
                                if (item.TYPE == "CAN AERIAL Extra") {
                                    yearCount = item.MIN_COUNT;
                                }
                            }
                            if (yearCount > pac.YEAR.length) {
                                flag = false;
                                $(".yearSummary").css({ "color": "red" });
                                $("#yearWarn").css({ "display": "block" });
                            } else {
                                $(".yearSummary").css({ "color": "black" });
                                $("#yearWarn").css({ "display": "none" });
                            }
                        }

                        product.product_code = pac.proP.PRODUCT_CODE;
                        product.order_id = orderId;
                        product.turnaround = pac.timeLine;
                        if ((pac.required.indexOf("OPTA") != -1) && (pac.OPTA != "")) {
                            product.input = pac.OPTA;
                        } else if ((pac.required.indexOf("COT") != -1) && (pac.COT != "")) {
                            product.input = pac.COT;
                        } else if ((pac.required.indexOf("LTS") != -1) && (pac.LTS.length != 0)) {
                            product.input = pac.LTS;
                        } else if ((pac.required.indexOf("NEPA") != -1) && (pac.NEPA.length != 0)) {
                            product.input = pac.NEPA;
                        } else if (pac.required.indexOf("PERMIT") != -1) {
                            if (pac.Other.length != 0) {
                                product.input = [pac.Other];
                                $(".permitSummary").css({ "color": "black" });
                                $("#permitWarn").css({ "display": "none" });
                            } else {
                                $(".permitSummary").css({ "color": "red" });
                                $("#permitWarn").css({ "display": "block" });
                                flag = false;
                            }
                        } else if ((pac.required.indexOf("YEAR") != -1) && (pac.YEAR.length != 0)) {
                            product.input = pac.YEAR;
                            if (pac.COMM != "") {
                                product.comment = pac.COMM;
                            }
                        }else if(pac.proP.PRODUCT_CODE=="CDS_11"||pac.proP.PRODUCT_CODE=="CDS_9"||pac.proP.PRODUCT_CODE=="CDS_8"||pac.proP.PRODUCT_CODE=="NEPA_US1"||pac.proP.PRODUCT_CODE=="NEPA_US2"){
                            if (pac.COMM.length != 0) {
                                product.comment = pac.COMM;
                            }
                        }
                        product.city_directory_street = pac.CD;
                        product.package_oid = Package_oid;
                        if (pac.proP.TYPE == "report") {
                            product.type = "report";
                            orderInfo.search_radius_increase = pac.plus;
                            orderInfo.distance_code = pac.radius;
                            orderInfo.data_sources = this.SelectedDataSourceCode;
                        } else {
                            product.type = "product";
                        }
                        orderInfo.products.push(product);
                    }
                }
            };
            $("#xpreReq").css("display", "none");
            $("#fimpreReq").css("display", "none");
            $("#OVERLAY").css({ "color": "black" });
            $("#OVERLAY_CA").css({ "color": "black" });
            $("#xplorerWarn").css({ "display": "none" });
            $("#fimWarn").css({ "display": "none" });
            $("#FIM_2").css({ "color": "black" });
            let allselectedPro = [];
            if ((this.selectedPac) && (this.packageAll)) {
                for (let pac of this.packageAll) {
                    let product_code = pac.proP.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            }
            if (this.selectedPro) {
                for (let pro of this.selectedPro) {
                    let product_code = pro.Spro.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            };
            if (this.selectedRpt) {
                for (let rpt of this.selectedRpt) {
                    let product_code = rpt.Srpt.PRODUCT_CODE;
                    allselectedPro.push(product_code);
                }
            };
            if (this.selectedPro) {
                let pros = this.selectedPro;
                for (let pro of pros) {
                    if ((pro.Spro.PRODUCT_CODE == 'OVERLAY') || (pro.Spro.PRODUCT_CODE == 'OVERLAY_CA')) {
                        let sign = 0;
                        for (let singlepro of allselectedPro) {
                            if (this.xReqCode.indexOf(singlepro) != -1) {
                                sign++;
                            }
                        }
                        if (sign <= 0) {
                            flag = false;
                            $("#xpreReq").css("display", "block");
                            $("#OVERLAY").css({ "color": "red" });
                            $("#OVERLAY_CA").css({ "color": "red" });
                            $("#xplorerWarn").css({ "display": "block" });
                            return
                        }
                    } else if (pro.Spro.PRODUCT_CODE == 'FIM_2') {

                        let sign = 0;
                        for (let singlepro of allselectedPro) {
                            if (this.fimReqCode.indexOf(singlepro) != -1) {
                                sign++;
                            }
                        }
                        if (sign <= 0) {
                            flag = false;
                            $("#fimpreReq").css("display", "block");
                            $("#FIM_2").css({ "color": "red" });
                            $("#fimWarn").css({ "display": "block" });
                            return
                        }
                    }
                    if (pro.Spro.PRODUCT_CODE == "VEC_US1") {
                        let sign = 0;
                        for (let singlepro of allselectedPro) {
                            if (this.vaporReqCode.indexOf(singlepro) != -1) {
                                sign++;
                            }
                        }
                        if (sign <= 0) {
                            flag = false;
                            $("#vaporWarn").css("display", "block");
                            $("#vaporWarn2").css({ "display": "block" });
                            return
                        }
                    }
                    let product = {
                        "order_id": "",
                        "order_num": "",
                        "product_code": "",
                        "type": "product",
                        "quote_requested": "",
                        "turnaround": "",  //------NUMBER
                        "input": null,
                        "comment": "",
                        "city_directory_street": [],
                        "package_oid": "",
                    }
                    if (pro.Spro.PRODUCT_CODE == cdId) {
                        for (let item of pro.Spro.REQUIRED_FIELDS) {
                            if (item.TYPE == "CD Extra") {
                                cdminCount = item.MIN_COUNT;
                            }
                        }
                        if (cdminCount > pro.CD.length) {
                            flag = false;
                            $(".cdSummary").css({ "color": "red" });
                            $("#miniWarn").css({ "display": "block" });
                        } else {
                            $(".cdSummary").css({ "color": "black" });
                            $("#miniWarn").css({ "display": "none" });
                        }
                    }
                    if (pro.Spro.PRODUCT_CODE == ltsId) {
                        for (let item of pro.Spro.REQUIRED_FIELDS) {
                            if (item.TYPE == "LTS Extra") {
                                ltsCount = item.MIN_COUNT;
                            }
                        }
                        if (ltsCount > pro.LTS.length) {
                            flag = false;
                            $(".ltsSummary").css({ "color": "red" });
                            $("#ltsWarn").css({ "display": "block" });
                        } else {
                            $(".ltsSummary").css({ "color": "black" });
                            $("#ltsWarn").css({ "display": "none" });
                        }
                    }
                    if (pro.Spro.PRODUCT_CODE == cotId) {
                      for (let item of pro.Spro.REQUIRED_FIELDS) {
                          if (item.TYPE == "COT Extra") {
                              cotCount = item.MIN_COUNT;
                          }
                      }
                      if (cotCount > pro.COT.length) {
                          flag = false;
                          $(".cotSummary").css({ "color": "red" });
                          $("#cotWarn").css({ "display": "block" });
                      } else {
                          $(".cotSummary").css({ "color": "black" });
                          $("#cotWarn").css({ "display": "none" });
                      }
                  }
                    if (pro.Spro.PRODUCT_CODE == yearId) {
                        for (let item of pro.Spro.REQUIRED_FIELDS) {
                            if (item.TYPE == "CAN AERIAL Extra") {
                                yearCount = item.MIN_COUNT;
                            }
                        }
                        if (yearCount > pro.YEAR.length) {
                            flag = false;
                            $(".yearSummary").css({ "color": "red" });
                            $("#yearWarn").css({ "display": "block" });
                        } else {
                            $(".yearSummary").css({ "color": "black" });
                            $("#yearWarn").css({ "display": "none" });
                        }
                    }
                    product.product_code = pro.Spro.PRODUCT_CODE;

                    product.order_id = orderId;
                    product.turnaround = pro.timeLine;
                    if ((pro.required.indexOf("OPTA") != -1) && (pro.OPTA != "")) {
                        product.input = pro.OPTA;
                    } else if ((pro.required.indexOf("COT") != -1) && (pro.COT != "")) {
                        product.input = pro.COT;
                    } else if ((pro.required.indexOf("LTS") != -1) && (pro.LTS.length != 0)) {
                        product.input = pro.LTS;
                    } else if ((pro.required.indexOf("NEPA") != -1) && (pro.NEPA.length != 0)) {
                        product.input = pro.NEPA;
                    }
                    if (pro.required.indexOf("COMM") != -1) {
                        if (pro.COMM.length == 0) {
                            flag = false;
                            $(".commSummary").css({ "color": "red" });
                            $("#procommWarn").css({ "display": "block" });
                        } else {
                            product.comment = pro.COMM;
                            $(".commSummary").css({ "color": "black" });
                            $("#procommWarn").css({ "display": "none" });
                        }
                    } else if (pro.required.indexOf("PERMIT") != -1) {
                        if (pro.Other.length != 0) {
                            product.input = [pro.Other];
                            $(".permitSummary").css({ "color": "black" });
                            $("#permitWarnWarn").css({ "display": "none" });
                        } else {
                            $(".permitSummary").css({ "color": "red" });
                            $("#permitWarnWarn").css({ "display": "block" });
                            flag = false;
                        }
                    } else if ((pro.required.indexOf("YEAR") != -1) && (pro.YEAR.length != 0)) {
                        product.input = pro.YEAR;
                        if (pro.COMM.length != 0) {
                            product.comment = pro.COMM;
                        }
                    }
                     else if(product.product_code=="CDS_11"||product.product_code=="CDS_9"||product.product_code=="CDS_8"||product.product_code=="NEPA_US1"||product.product_code=="NEPA_US2"){
                        if (pro.COMM.length != 0) {
                            product.comment = pro.COMM;
                        }
                    }
                    product.city_directory_street = pro.CD;
                    orderInfo.products.push(product);
                }
            }

            if (this.selectedRpt) {
                let rpts = this.selectedRpt;
                for (let rpt of rpts) {
                    if (rpt.required.indexOf('source') != -1) {
                        dataSourceRequired = true;
                    }
                    let report = {
                        "order_id": "",
                        "order_num": "",
                        "product_code": "",
                        "type": "report",
                        "quote_requested": "",
                        "turnaround": "",
                        "input": null,
                        "comment": "",
                        "city_directory_street": [],
                        "buffer_size": "",
                        "package_oid": "",
                    }
                    if (rpt.Srpt.PRODUCT_CODE == bufferId) {

                        if (rpt.Buffer == "") {
                            flag = false;
                            $(".bufferSummary").css({ "color": "red" });
                            $("#bufferWarn").css({ "display": "block" });
                        } else {
                            $(".bufferSummary").css({ "color": "black" });
                            $("#bufferWarn").css({ "display": "none" });
                        }
                    }
                    report.product_code = rpt.Srpt.PRODUCT_CODE;
                    if (rpt.COMM.length != 0) {
                        report.input = [rpt.COMM];
                    }

                    report.order_id = orderId;
                    report.turnaround = rpt.timeLine;
                    if (rpt.Buffer) report.buffer_size = rpt.Buffer;
                    orderInfo.search_radius_increase = rpt.plus;
                    orderInfo.distance_code = rpt.radius;
                    orderInfo.data_sources = this.SelectedDataSourceCode;
                    orderInfo.products.push(report);
                }
            }

            if (dataSourceRequired) {
                if (this.SelectedDataSource.length == 0) {
                    flag = false;
                    $(".dataSourceWarn").each(function () {
                        $(this).css({ "color": "red", "display": "block" });
                    })
                    $(".sourceSummary").each(function () {
                        $(this).css({ "color": "red" });
                    })
                } else {
                    $(".dataSourceWarn").each(function () {
                        $(this).css({ "color": "red", "display": "none" });
                    })
                    $(".sourceSummary").each(function () {
                        $(this).css({ "color": "black" });
                    })
                }
            }

            if (orderInfo.products.length == 0) {
                $("#noSelectedPro").css({ "display": "block" });
                flag = false
            }

            if (!flag) {
                return
            }

            this.cookieService.setCookieSession("DataSources", JSON.stringify(this.SelectedDataSource));
            this.cookieService.setCookieSession("DataSourcesCode", JSON.stringify(this.SelectedDataSourceCode));
            if ((this.selectedPac) && (this.packageAll.length != 0)) {
                this.cookieService.setCookieSession('Package', JSON.stringify(this.selectedPac));
                this.cookieService.setCookieSession('PackageAll', JSON.stringify(this.packageAll));
            }
            if (this.selectedPro) {
                this.cookieService.setCookieSession('Product', JSON.stringify(this.selectedPro));
            }
            if (this.selectedRpt) {
                this.cookieService.setCookieSession('Report', JSON.stringify(this.selectedRpt));
            }

            this.cookieService.setCookieSession("Order", JSON.stringify(orderInfo));
        }

        let hisOrder = false;
        for (let singlepro of orderInfo.products) {
            if (singlepro.product_code == "AP_US3") hisOrder = true;
        }
        if ((hisOrder) && (this.cookieService.getCookie('geoType') !== 'multipolygon') && (this.cookieService.getCookie('geoType') != "polygon") && (this.cookieService.getCookie('geoType') != "polyline") && (this.cookieService.getCookie('geoType') != "kml")) {
            $("#hisWarn").css('display', 'block');
            if (!$("#geoAgree").prop('checked')) return;
        }

        this.ngZone.run(() => {
            this.router.navigate(['/summary']);
        });
    }

    public sourceOnSelection(source, event): void {
        if ((event.target).checked) {
            $(".dataSourceWarn").each(function () {
                $(this).css({ "display": "none" });
            })
            this.SelectedDataSource.push(source.NAME);
            this.SelectedDataSourceCode.push(source.DS_OID);
        } else {
            const index: number = this.SelectedDataSource.indexOf(source.NAME);
            if (index != -1) {
                this.SelectedDataSource.splice(index, 1);
                this.SelectedDataSourceCode.splice(index, 1);
            }
        }
    }

    public dataSourcesToggle(): void {
        if ($("#dataSourcesContainer").css("display") == "none") {
            document.getElementById("dataSourcesContainer").removeAttribute("style")
        } else {
            $("#dataSourcesContainer").css("display", "none");
        }
    }

    public rptPanelToggle(event, id, btn): void {
        if ($('#' + id).css('display') == 'block') {
            $('#' + id).css('display', 'none');
            $('#' + btn).html('<i class="fa fa-plus-square-o"></i>');
        } else {
            $('#' + id).css('display', 'block');
            $('#' + btn).html('<i class="fa fa-minus-square-o"></i>');
        }
    }

    public packageToggle(): void {
        if ($('#pacPanel').css('display') == 'block') {
            $('#pacPanel').css('display', 'none');
            $('#pacBtn').html('<i class="fa fa-plus-square-o"></i>');
        } else {
            $('#pacPanel').css('display', 'block');
            $('#pacBtn').html('<i class="fa fa-minus-square-o"></i>');
        }
    }

    public hidePacDetail($event): void {
        if ($('#pacSummary').css('display') == 'none') {
            $('#pacSummary').css('display', 'block');
            this.collapseBthText = '<i class="fa fa-minus-square-o"></i>';
        } else {
            $('#pacSummary').css('display', 'none');
            this.collapseBthText = '<i class="fa fa-plus-square-o"></i>';
        }
    }

    public editPac(): void {
        $("#packageTab").trigger("click");
    }

    public editPro(ID): void {
        $("#productTab").trigger("click");
        $('.btn-plus').each(function () {
            if ($(this).html().indexOf("fa-minus-square-o") > -1) {
                $(this).trigger("click");
            }
        })
        let proName = '#' + ID + 'btn';
        if ($(proName).html() !== undefined && $(proName).html().indexOf("fa-plus-square-o") > -1) {
            $(proName).trigger("click");
        }
    }

    public editRpt(ID): void {
        $("#productTab").trigger("click");
        $('.btn-plus').each(function () {
            if ($(this).html().indexOf("fa-minus-square-o") > -1) {
                $(this).trigger("click");
            }
        })
        let rptName = '#' + ID + 'btn';
        if ($(rptName).html() !== undefined && $(rptName).html().indexOf("fa-plus-square-o") > -1) {
            $(rptName).trigger("click");
        }
    }

    public chooseStreet(): void {
        $("#modalSearchWarn").css("display", "none");
        $(".modalInvalidWarn").css("display", "none");
        if ($("#modalStreetName").val() == "") {
            $("#modalSearchWarn").css("display", "block");
            return
        }
        if ((($("#modalStreetName").prop("value")).indexOf(",") != -1) || (($("#modalStreetName").prop("value")).indexOf(";") != -1)) {
            $(".modalInvalidWarn").css("display", "block");
            return;
        }
        if ((this.currentCode != "") && (this.currentMax != "")) {
            this.addStreet(this.currentCode, this.currentMax, 'modalInput');
        }
        $("#modalStreetName").val("");
        $("#modalStreetNo").val("");
        $("#modalStreetNote").val("");
        $("#mapModal").modal("hide");
    }

    public mapModalOpen(code, max) {
        $("#mapModal").modal("show");
        $("#modalSearchWarn").css("display", "none");
        $(".modalInvalidWarn").css("display", "none");
        $('#search').val('');
        $("#modalStreetName").val("");
        $("#modalStreetNo").val("");
        $("#modalStreetNote").val("");
        this.currentCode = code;
        this.currentMax = max;
    }

    public toProducts(): void {
        $("#productTab").trigger("click");
    }

    public checkBoxesToggle(bool) {
        let checkboxes = $('.dscheck');
        for (let i = 0; i < checkboxes.length; i++) {
            if (bool) {
                if (!checkboxes[i].checked) {
                    checkboxes[i].checked = true;
                    this.SelectedDataSource.push(checkboxes[i].value);
                    this.SelectedDataSourceCode.push(checkboxes[i].id);
                }
            } else {
                if (checkboxes[i].checked) {
                    checkboxes[i].checked = false;
                    this.removeDataSource(checkboxes[i].value)
                }
            }
        }
    }

    removeDataSource(name) {
        const index: number = this.SelectedDataSource.indexOf(name);
        if (index != -1) {
            this.SelectedDataSource.splice(index, 1);
            this.SelectedDataSourceCode.splice(index, 1);
        }
    }

    toNumber(evt): void {
        if (evt.which < 46 || evt.which > 57 || evt.which == 47) {
            evt.preventDefault();
        }
    }

    saveUserInput() {
        if ($("#editedAddress").val()) {
            let inputAddress = $("#editedAddress").val();
            let modifiedinput = inputAddress.replace(/,/g, '\U002C');
            this.cookieService.setCookieSession("userInput", modifiedinput);
        }
    }

    saveInputCity() {
        let orderInfo: any
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'));
        } else if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        }
        if ($("#editedC1").val()) {
            orderInfo.city = $("#editedC1").val();
            this.cookieService.setCookieSession("Order", JSON.stringify(orderInfo));
        }
    }
}
